/* The3Beez Studio — theme.js (v0.1). No dependencies. */
(function () {
  "use strict";
  var T = window.T3B || {};
  /* Locale prefix for every URL this file builds: "" on Arabic, "/en" on English. Without it,
     every fetch below returns Arabic titles into the English storefront, and every JS-built link
     drops the customer out of /en without warning. Liquid-rendered URLs localize themselves —
     only JS-built ones pass through here. */
  var ROOT = T.root && T.root !== "/" ? String(T.root).replace(/\/$/, "") : "";
  var RM =
    matchMedia("(prefers-reduced-motion: reduce)").matches ||
    document.body.dataset.motion === "off";

  function $(s, c) {
    return (c || document).querySelector(s);
  }
  function $$(s, c) {
    return [].slice.call((c || document).querySelectorAll(s));
  }

  /* 2026-10-09 (animations without slowdown, base.css "REWRITTEN" block):
     1. html.awake while the visitor is doing something and for 8 s after - the decorations that move a
        shape inside a drawing (logo wing, door icon, promo icons, badge glint) run only then, because
        they cost a repaint per frame; the compositor-cheap ones run always.
     2. Content sections outside the viewport get data-offscreen and base.css pauses every animation in
        them. Only #MainContent sections: the header group is sticky and the fabs are fixed, so their
        wrappers must never be marked. */
  var awakeTimer = null;
  function wake() {
    document.documentElement.classList.add("awake");
    clearTimeout(awakeTimer);
    awakeTimer = setTimeout(function () {
      document.documentElement.classList.remove("awake");
    }, 8000);
  }
  ["scroll", "touchstart", "pointerdown", "keydown", "wheel"].forEach(function (ev) {
    addEventListener(ev, wake, { passive: true });
  });
  if ("IntersectionObserver" in window) {
    var offIO = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) e.target.removeAttribute("data-offscreen");
          else e.target.setAttribute("data-offscreen", "");
        });
      },
      { rootMargin: "20% 0px 20% 0px" },
    );
    $$("#MainContent .shopify-section").forEach(function (s) {
      offIO.observe(s);
    });
  }

  var SOLO = null;
  function soloSVG() {
    if (!SOLO) {
      var t = $("#flybee");
      SOLO = t ? t.innerHTML : "";
    }
    return SOLO;
  }

  /* A-265: threshold 0, NOT 0.12. intersectionRatio is visible-area over ELEMENT area, so an
     element ~8x taller than the viewport can never reach 12% visible - the comparison page's
     .prose sat permanently invisible on phones because of exactly this. Any visible pixel now
     reveals; base.css carries a pure-CSS deadline (rvguard) for the case this code never runs. */
  var io = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("rvin");
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0 },
  );
  $$(".rv").forEach(function (x) {
    io.observe(x);
  });

  /* Honey shade scale: order the swatches palest to darkest.
   *
   * ENHANCEMENT ONLY. Liquid cannot turn a hex string into a luminance value, so the sort lives
   * here. If this never runs the swatches still render, still link and still name themselves —
   * they just appear in collection order. The order is the idea, but it is not the function.
   *
   * Perceived brightness, not a plain average: the eye reads green as far brighter than blue, and
   * a flat mean would put a deep amber and a dull olive in the wrong places on a scale whose
   * whole point is that it matches what you see.
   *
   * `$$`, NOT `$`. Both of these were the singular helper, which returns ONE element or null. Once
   * the shade scale came off the homepage it returned null, `null.forEach` threw at the top level
   * of this IIFE, and every feature defined below here — the flying bee, Quick add, the stat
   * count-up, hero autoplay — silently stopped existing. `$$` returns [] when the section is
   * absent, so this block is now a no-op rather than a landmine. */
  $$("[data-shade-track]").forEach(function (track) {
    var drops = $$(".shadedrop", track);
    if (drops.length < 2) return;

    function luminance(hex) {
      var h = String(hex || "")
        .trim()
        .replace("#", "");
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      if (!/^[0-9a-fA-F]{6}$/.test(h))
        return -1; /* unparseable sinks to the start */
      var r = parseInt(h.slice(0, 2), 16),
        g = parseInt(h.slice(2, 4), 16),
        b = parseInt(h.slice(4, 6), 16);
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }

    drops
      .map(function (el) {
        return { el: el, l: luminance(el.getAttribute("data-shade")) };
      })
      .sort(function (a, b) {
        return b.l - a.l;
      }) /* palest first */
      .forEach(function (d) {
        track.appendChild(d.el);
      });
  });

  /* Hero slides: dots and auto-advance. ENHANCEMENT ONLY.
   *
   * The strip is a CSS scroll-snap container, so every slide is already reachable by swiping,
   * trackpad or keyboard before this runs. Nothing here is required to see slide two — which is
   * the difference between a carousel and a carousel that sometimes hides half its content.
   *
   * Slides are moved between by scrolling the TRACK by a relative delta, never by scrollIntoView
   * and never by assigning scrollLeft. All three deserve an explanation because two of them are
   * wrong in ways that are invisible until they are not:
   *
   *   - `scrollLeft = x` is wrong because in RTL its origin and sign differ between engines, and
   *     this storefront is RTL by default. The bug would appear only in Arabic — the primary
   *     locale — which is the worst possible place to hide one.
   *   - `scrollIntoView` is wrong because it scrolls EVERY ancestor scroll container, including the
   *     document. Auto-advance a slide while the visitor is halfway down the page and the whole
   *     page yanks back up to the hero. `block:'nearest'` does not save you: nearest still scrolls
   *     when the element is entirely out of view, which is exactly the case that matters. This
   *     shipped, and the owner reported it.
   *   - A relative delta from getBoundingClientRect fed to track.scrollBy is direction-agnostic,
   *     because it is measured from rendered geometry rather than from a coordinate system whose
   *     origin flips in RTL — and it touches nothing but the track.
   *
   * Only VISIBLE slides count. Video slides are hidden on desktop by CSS, so a dot per block
   * would produce dots that scroll to nothing. */
  $$("[data-hero-slides]").forEach(function (root) {
    var track = $("[data-hero-track]", root);
    if (!track) return;

    function visibleSlides() {
      return $$(".heroslide", track).filter(function (s) {
        return s.offsetParent !== null;
      });
    }
    var slides = visibleSlides();
    if (slides.length < 2) return; /* one slide is not a carousel */

    /* Horizontal, on the track, and on nothing else. See the note above for why this is not
       scrollIntoView and not scrollLeft. */
    function goTo(slide) {
      var delta =
        slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (!delta) return;
      track.scrollBy({ left: delta, behavior: RM ? "auto" : "smooth" });
    }

    /* 2026-10-08 (home-page weight): slides after the first carry their picture set in
       data-srcset and start at 600 px (sections/hero.liquid). The current slide and the next get
       the full set here, so a hidden slide costs nothing until it is about to show. */
    function primeSlides(i) {
      [i, i + 1].forEach(function (k) {
        var s = slides[k % slides.length];
        if (!s) return;
        var im = s.querySelector("img[data-srcset]");
        if (!im) return;
        im.setAttribute("srcset", im.getAttribute("data-srcset"));
        im.setAttribute("sizes", im.getAttribute("data-sizes") || "100vw");
        im.removeAttribute("data-srcset");
      });
    }

    var dots = document.createElement("div");
    dots.className = "heroslides-dots";
    /* Rebuildable, because the VISIBLE set is not fixed: video slides are display:none on desktop,
       so rotating a tablet across the breakpoint changes which slides exist as far as the carousel
       is concerned — and the old one-time snapshot kept dots that scrolled to nothing (audit P3). */
    function buildDots() {
      slides = visibleSlides();
      dots.innerHTML = "";
      slides.forEach(function (slide, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", String(i + 1));
        b.addEventListener("click", function () {
          goTo(slide);
        });
        dots.appendChild(b);
      });
      markCurrent();
    }
    root.appendChild(dots);
    buildDots(); /* markCurrent is a hoisted declaration, so calling it from here is safe */
    var rsTimer;
    addEventListener("resize", function () {
      clearTimeout(rsTimer);
      rsTimer = setTimeout(function () {
        if (visibleSlides().length !== slides.length) buildDots();
      }, 150);
    });

    function markCurrent() {
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
      var best = 0,
        bestD = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) {
          bestD = d;
          best = i;
        }
      });
      $$("button", dots).forEach(function (b, i) {
        if (i === best) b.setAttribute("aria-current", "true");
        else b.removeAttribute("aria-current");
      });
      primeSlides(best);
      return best;
    }
    var scrollTimer;
    track.addEventListener(
      "scroll",
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(markCurrent, 80);
      },
      { passive: true },
    );
    markCurrent();

    /* Auto-advance. Off for reduced motion, off if the merchant turned it off, and it stops for
       good the moment someone touches the strip.

       A single interval could not express "this slide is 3 seconds and that one runs as long as
       it runs", so each slide schedules the next itself: an image waits the configured seconds,
       a video waits until it has finished playing.

       The markup keeps loop enabled so a visitor without JavaScript sees a looping video. Loop is
       turned off here only because we have more than one slide and are sequencing them; a lone
       video would otherwise stop dead on its final frame.

       IT MUST NOT BE ABLE TO STICK. If a video never loads, is blocked from autoplaying, or fires
       no ended event, a purely event-driven carousel freezes on that slide forever. Every video
       therefore also carries a fallback timer derived from its own duration, with a ceiling for
       when the duration is unknown. */
    if (RM || root.getAttribute("data-autoplay") !== "true") return;
    var secs = Number(root.getAttribute("data-seconds")) || 6;
    var timer = null,
      stopped = false;
    var FALLBACK_MAX = 30000;

    function goNext() {
      if (stopped) return;
      /* A-389: `% 0` is NaN, and slides[NaN] is undefined - goTo() then threw and the
         whole auto-advance died silently. Not reachable in the current hero (it needs a
         breakpoint that hides every slide), but a swallowed exception here is the kind
         of thing that only shows up as "the carousel stopped working". */
      if (!slides.length) return;
      var next = (markCurrent() + 1) % slides.length;
      goTo(slides[next]);
      setTimeout(
        schedule,
        600,
      ); /* let the snap settle before reading position */
    }

    function schedule() {
      if (stopped) return;
      clearTimeout(timer);
      var slide = slides[markCurrent()];
      var vid = slide.querySelector("video");

      if (!vid) {
        timer = setTimeout(goNext, secs * 1000);
        return;
      }

      vid.loop = false;
      /* Restart it, or the second time round it advances instantly from where it was left. */
      try {
        vid.currentTime = 0;
        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function () {});
      } catch (e) {}

      if (!vid.dataset.heroBound) {
        vid.dataset.heroBound = "1";
        vid.addEventListener("ended", goNext);
      }
      var ms =
        isFinite(vid.duration) && vid.duration > 0
          ? vid.duration * 1000 + 800
          : FALLBACK_MAX;
      timer = setTimeout(goNext, Math.min(ms, FALLBACK_MAX));
    }

    schedule();

    ["pointerdown", "touchstart", "wheel", "keydown"].forEach(function (ev) {
      root.addEventListener(
        ev,
        function () {
          stopped = true;
          clearTimeout(timer);
          /* A-389: GIVE LOOP BACK. Sequencing is the only reason it was borrowed (see
             the note above: "The markup keeps loop enabled so a visitor without
             JavaScript sees a looping video"). Once auto-advance stops, that reason is
             gone - but loop stayed false, so the playing video ran to its end and froze
             on the last frame for the rest of the visit. Swiping back to that slide
             later showed a dead still with nothing able to restart it. */
          root.querySelectorAll("video").forEach(function (v) {
            v.loop = true;
          });
        },
        { passive: true, once: true },
      );
    });
  });

  /* A-476: product swipe rows (featured-products, "Swipe row" layout). The row itself is CSS
     scroll-snap and needs none of this: touch swipes it and the keyboard reaches every card.
     This only gives a MOUSE a way to move it - two arrow buttons, shown by CSS on hover-capable
     devices only, each visible only while there is more in its direction. Direction-agnostic
     the way the hero is: "is there more" is read from rendered rectangles and the move is a
     relative scrollBy - never scrollLeft, whose origin and sign differ in RTL. */
  $$("[data-prow]").forEach(function (root) {
    var track = $("[data-prow-track]", root),
      prev = $("[data-prow-prev]", root),
      next = $("[data-prow-next]", root);
    if (!track || !prev || !next) return;
    function update() {
      var cards = track.children;
      if (!cards.length) return;
      var t = track.getBoundingClientRect(),
        a = cards[0].getBoundingClientRect(),
        b = cards[cards.length - 1].getBoundingClientRect(),
        moreLeft = Math.min(a.left, b.left) < t.left - 1,
        moreRight = Math.max(a.right, b.right) > t.right + 1;
      /* "next" runs with the reading direction: leftwards in Arabic, rightwards in English */
      next.hidden = !(T.rtl ? moreLeft : moreRight);
      prev.hidden = !(T.rtl ? moreRight : moreLeft);
    }
    function move(dir) {
      track.scrollBy({
        left: dir * (T.rtl ? -1 : 1) * track.clientWidth * 0.8,
        behavior: RM ? "auto" : "smooth",
      });
    }
    next.addEventListener("click", function () {
      move(1);
    });
    prev.addEventListener("click", function () {
      move(-1);
    });
    var prowTimer;
    function queue() {
      clearTimeout(prowTimer);
      prowTimer = setTimeout(update, 80);
    }
    track.addEventListener("scroll", queue, { passive: true });
    addEventListener("resize", queue);
    update();

    /* 2026-10-08 (home-page weight): cards past the third in a swipe row start at 300 px with
       the full set in data-srcset (snippets/product-card.liquid, defer). Each gets the full set
       when it comes within a quarter-screen of the viewport, sideways or down. Without
       IntersectionObserver the 300 px picture simply stays. */
    var deferred = $$("img[data-srcset]", track);
    if (deferred.length && "IntersectionObserver" in window) {
      var dio = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var im = e.target;
            im.setAttribute("srcset", im.getAttribute("data-srcset"));
            im.setAttribute("sizes", im.getAttribute("data-sizes") || "(max-width: 900px) 50vw, 300px");
            im.removeAttribute("data-srcset");
            dio.unobserve(im);
          });
        },
        { rootMargin: "25% 25% 25% 25%" },
      );
      deferred.forEach(function (im) {
        dio.observe(im);
      });
    }
  });

  /* A-487: image-banner slider (sections/image-banner.liquid holding two or more pictures).
     ENHANCEMENT ONLY, the hero's way: the strip is CSS scroll-snap, so swiping and the keyboard
     already work before this runs. This adds the dots, two arrows for a MOUSE (the product rows'
     .prow-nav, shown by CSS on hover-capable devices only) and - only if the owner switched it
     on - automatic movement.

     Moves are a relative scrollBy on the track, measured from rendered rectangles: never
     scrollLeft (its origin and sign differ in RTL) and never scrollIntoView (it scrolls the
     page too). The arrows step from the slide last ASKED for, not the one measured, so two
     quick clicks during a smooth scroll move two slides instead of one.

     Automatic movement runs only while the banner is on screen, never for reduced motion, and
     stops for good at the first touch, click, wheel or key - as the hero's does. */
  function ibInit(root) {
    if (root.dataset.ibOn) return;
    var track = $("[data-ib-track]", root),
      prev = $("[data-ib-prev]", root),
      next = $("[data-ib-next]", root);
    if (!track) return;
    var slides = $$(".imgban-slide", track);
    if (slides.length < 2) return; /* one picture is not a slider */
    root.dataset.ibOn = "1";
    var want = 0;

    function current() {
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
      var best = 0,
        bestD = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) {
          bestD = d;
          best = i;
        }
      });
      return best;
    }
    function goTo(i) {
      want = i;
      var delta =
        slides[i].getBoundingClientRect().left -
        track.getBoundingClientRect().left;
      if (!delta) return;
      track.scrollBy({ left: delta, behavior: RM ? "auto" : "smooth" });
    }

    var dots = document.createElement("div");
    dots.className = "imgban-dots";
    slides.forEach(function (s, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", String(i + 1));
      b.addEventListener("click", function () {
        goTo(i);
      });
      dots.appendChild(b);
    });
    root.appendChild(dots);

    function mark() {
      var c = current();
      want = c;
      $$("button", dots).forEach(function (b, i) {
        if (i === c) b.setAttribute("aria-current", "true");
        else b.removeAttribute("aria-current");
      });
      if (prev) prev.hidden = c === 0;
      if (next) next.hidden = c === slides.length - 1;
    }
    if (prev)
      prev.addEventListener("click", function () {
        goTo(Math.max(0, want - 1));
      });
    if (next)
      next.addEventListener("click", function () {
        goTo(Math.min(slides.length - 1, want + 1));
      });
    var ibTimer;
    function queue() {
      clearTimeout(ibTimer);
      ibTimer = setTimeout(mark, 80);
    }
    track.addEventListener("scroll", queue, { passive: true });
    addEventListener("resize", queue);
    mark();

    if (RM || root.getAttribute("data-autoplay") !== "true") return;
    var secs = Number(root.getAttribute("data-seconds")) || 5,
      auto = null,
      stopped = false,
      seen = false;
    function tick() {
      clearTimeout(auto);
      if (stopped || !seen) return;
      auto = setTimeout(function () {
        if (stopped || !seen) return;
        goTo((current() + 1) % slides.length);
        tick();
      }, secs * 1000);
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (es) {
          seen = es[0].isIntersecting;
          tick();
        },
        { threshold: 0.5 },
      ).observe(root);
    } else {
      seen = true;
      tick();
    }
    ["pointerdown", "touchstart", "wheel", "keydown"].forEach(function (ev) {
      root.addEventListener(
        ev,
        function () {
          stopped = true;
          clearTimeout(auto);
        },
        { passive: true, once: true },
      );
    });
  }
  $$("[data-ib-slides]").forEach(ibInit);
  /* Theme editor only: a section re-rendered after the owner adds a picture gets its dots and
     arrows without a reload, and the Picture block he selects is the slide he sees. These events
     never fire on the live storefront. */
  document.addEventListener("shopify:section:load", function (e) {
    $$("[data-ib-slides]", e.target).forEach(ibInit);
  });
  document.addEventListener("shopify:block:select", function (e) {
    var s = e.target;
    if (!s || !s.classList || !s.classList.contains("imgban-slide")) return;
    var tr = s.parentNode;
    tr.scrollBy({
      left: s.getBoundingClientRect().left - tr.getBoundingClientRect().left,
      behavior: "auto",
    });
  });

  /* A-502: the product page's top line (sections/main-product.liquid, base.css .ptop).
     Two small panels, both closed until asked for and both closed again by a tap outside or
     Escape:
     - the shelf: the breadcrumb collection's other products. Its row carries data-prow, so the
       swipe-row code above already gives a mouse its two arrows; that code measured the row
       while it was hidden, so a "scroll" event is sent on opening to make it measure again.
     - the share menu. A touch device with its own share sheet gets that sheet instead (it lists
       WhatsApp and the rest); the menu - WhatsApp, copy link - is for everything else.
     What is shared comes from the page, never from this file: the owner's sentence, the
     product's name and its address. The address goes through URL() so an Arabic handle is
     percent-encoded - a raw one is cut short when a chat app turns it into a link. */
  $$("[data-ptop]").forEach(function (root) {
    var shelf = $("[data-shelf]", root),
      tog = $("[data-shelf-toggle]", root),
      share = $("[data-pshare]", root),
      sbtn = share && $("[data-pshare-btn]", share),
      menu = share && $("[data-pshare-menu]", share);
    function setShelf(open) {
      if (!shelf || !tog) return;
      shelf.hidden = !open;
      tog.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) {
        var tr = $("[data-prow-track]", shelf);
        if (tr) tr.dispatchEvent(new Event("scroll"));
      }
    }
    function setMenu(open) {
      if (!menu || !sbtn) return;
      menu.hidden = !open;
      sbtn.setAttribute("aria-expanded", open ? "true" : "false");
    }
    function payload() {
      var title = share.getAttribute("data-title") || document.title,
        text = share.getAttribute("data-text") || "",
        url;
      try {
        url = new URL(share.getAttribute("data-url"), location.href).href;
      } catch (err) {
        url = location.href;
      }
      return { title: title, text: text ? text + "\n" + title : title, url: url };
    }
    /* A-503: the back button. A visitor who came from a page of this site steps back in their
       own history (the collection keeps its scroll position); anyone else - an ad, a search, a
       shared link - has no page of ours behind them, so the link's own address is followed. */
    var back = $("[data-ptop-back]", root);
    if (back)
      back.addEventListener("click", function (e) {
        var ref = document.referrer || "";
        if (history.length > 1 && ref.indexOf(location.origin + "/") === 0) {
          e.preventDefault();
          history.back();
        }
      });
    if (tog)
      tog.addEventListener("click", function () {
        setMenu(false);
        setShelf(shelf.hidden);
      });
    if (sbtn)
      sbtn.addEventListener("click", function () {
        setShelf(false);
        if (navigator.share && matchMedia("(pointer: coarse)").matches) {
          /* closing the sheet without sharing rejects the promise - that is not an error */
          navigator.share(payload()).catch(function () {});
          return;
        }
        setMenu(menu.hidden);
      });
    if (menu)
      menu.addEventListener("click", function (e) {
        var b = e.target.closest ? e.target.closest("[data-pshare-do]") : null;
        if (!b) return;
        var p = payload(),
          kind = b.getAttribute("data-pshare-do");
        if (kind === "wa") {
          window.open(
            "https://wa.me/?text=" + encodeURIComponent(p.text + "\n" + p.url),
            "_blank",
            "noopener",
          );
          setMenu(false);
        } else if (kind === "copy") {
          /* "Link copied" is shown only when a copy really happened. Some in-app browsers
             refuse the clipboard API; the old selection-based copy is tried before giving up,
             and a refusal of both leaves the button saying what it said. */
          var done = function () {
            var label = $("[data-pshare-label]", b),
              was = label ? label.textContent : "";
            if (!label || b.getAttribute("data-busy")) return;
            b.setAttribute("data-busy", "1");
            label.textContent = b.getAttribute("data-done") || was;
            setTimeout(function () {
              label.textContent = was;
              b.removeAttribute("data-busy");
              setMenu(false);
            }, 1600);
          };
          var legacy = function () {
            var ta = document.createElement("textarea"),
              ok = false;
            ta.value = p.url;
            ta.setAttribute("readonly", "");
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            try {
              ok = document.execCommand("copy");
            } catch (err) {}
            document.body.removeChild(ta);
            if (ok) done();
          };
          if (navigator.clipboard && navigator.clipboard.writeText)
            navigator.clipboard.writeText(p.url).then(done, legacy);
          else legacy();
        }
      });
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (shelf && !shelf.hidden && !shelf.contains(t) && !tog.contains(t))
        setShelf(false);
      if (menu && !menu.hidden && !share.contains(t)) setMenu(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (shelf && !shelf.hidden) {
        setShelf(false);
        tog.focus();
      }
      if (menu && !menu.hidden) {
        setMenu(false);
        sbtn.focus();
      }
    });
  });

  /* A full-width autoplaying hero video is precisely what prefers-reduced-motion is for. The
     markup ships with autoplay so the video works without JavaScript; this pauses it for anyone
     who has asked their system to stop moving content, and shows controls so they can start it
     themselves if they want to. */
  if (RM) {
    $$("[data-motion-pause]").forEach(function (v) {
      try {
        v.autoplay = false;
        v.pause();
        v.setAttribute("controls", "");
      } catch (e) {}
    });
  }

  /* Stat shields: count each number up from 0 the first time it scrolls into view.
   *
   * The final value is ALREADY in the HTML — Liquid renders it. This only animates from 0 up to
   * what is already there, so a visitor with JavaScript blocked, slow or broken reads the correct
   * figure instead of a row of zeros. Never invert that: a number that only JS can produce is a
   * number that sometimes is not produced.
   *
   * Reduced-motion users are left alone entirely; the number is already correct for them. */
  var statEls = $$("[data-count-to]");
  if (statEls.length) {
    if (RM) {
      /* nothing to do — the markup already shows the final value */
    } else {
      var sio = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            sio.unobserve(e.target);
            countUp(e.target);
          });
        },
        { threshold: 0.5 },
      );
      statEls.forEach(function (el) {
        sio.observe(el);
      });
    }
  }

  function countUp(el) {
    var target = Number(el.getAttribute("data-count-to"));
    if (!isFinite(target)) return;
    var pre = el.getAttribute("data-prefix") || "";
    var suf = el.getAttribute("data-suffix") || "";
    /* Duration comes from the section setting so the owner can tune it without asking.
       The number itself never depends on this - it is already in the HTML. */
    var DUR = Number(el.getAttribute("data-count-ms")) || 2000;
    var t0 = performance.now();
    (function step(now) {
      var raw = Math.min(1, (now - t0) / DUR);
      var eased = 1 - Math.pow(1 - raw, 3); /* ease-out: fast then settles */
      el.textContent = pre + Math.round(target * eased) + suf;
      if (raw < 1) requestAnimationFrame(step);
      else
        el.textContent =
          pre + target + suf; /* land exactly, never a rounding artefact */
    })(t0);
  }

  /* ── SIDEBAR DRAWER (A-143) ────────────────────────────────────────────────────────
     The burger's dropdown became an 80vw sidebar: collections, pages, account/cart/language,
     every list built from admin data in Liquid (Rule 0.5) — this module only opens, closes
     and swipes it.

     THE Z-INDEX LIFT: the panel lives outside .site-header (backdrop-filter trap) but inside
     the header's #shopify-section wrapper, which carries z-index:45 while pinned — lower than
     the cart bar's 55. On open the wrapper is lifted inline to 70; on close the lift is
     removed only after the slide-out finishes, so the departing panel does not drop behind
     the cart bar mid-flight. */
  (function () {
    var burger = $(".burger"),
      sb = $("[data-sbar]"),
      scrim = $("[data-sbar-scrim]");
    if (!burger || !sb || !scrim) return;
    var wrap = sb.closest(".shopify-section"),
      zT = null;
    /* A-389: `keepFocus` — close WITHOUT pulling focus back to the burger. Tapping the
       sidebar's cart row opens the cart drawer, a modal dialog; returning focus to the
       burger behind it meant a screen-reader user never heard the dialog open and had
       to tab back through the page to reach it. The cart drawer manages its own focus,
       so the sidebar simply gets out of the way. Every other close path still returns
       focus to the burger, which is correct — that IS where the user came from. */
    function sbShow(on, keepFocus) {
      if (on && wrap) {
        clearTimeout(zT);
        wrap.style.zIndex = 70;
      }
      sb.classList.toggle("open", on);
      scrim.classList.toggle("open", on);
      burger.setAttribute("aria-expanded", on);
      if (on) {
        var x = $("[data-sbar-close]", sb);
        if (x) x.focus();
      } else {
        if (wrap)
          zT = setTimeout(
            function () {
              wrap.style.zIndex = "";
            },
            RM ? 0 : 400,
          );
        if (!keepFocus) burger.focus();
      }
    }
    burger.addEventListener("click", function () {
      sbShow(!sb.classList.contains("open"));
    });
    scrim.addEventListener("click", function () {
      sbShow(false);
    });
    var sbX = $("[data-sbar-close]", sb);
    if (sbX)
      sbX.addEventListener("click", function () {
        sbShow(false);
      });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && sb.classList.contains("open")) sbShow(false);
    });
    /* Any link tap closes the drawer; the navigation itself proceeds. The cart row stays on
       the page — the cart module intercepts [data-open-cart] and opens its own drawer. */
    sb.addEventListener("click", function (e) {
      if (!e.target.closest("a")) return;
      /* A-389: the cart row opens a MODAL over this page rather than navigating away,
         so hand focus to it instead of yanking it back to the burger underneath. */
      sbShow(false, !!e.target.closest("[data-open-cart]"));
    });

    /* Swipe toward the burger's edge closes — the horizontal mirror of the cart drawer's
       pull-down. The panel follows the finger (only toward the hidden side), and release
       either commits past 90px or springs back via the base transition. */
    var sbSX = 0,
      sbSY = 0,
      sbDrag = false,
      sbWent = 0,
      sbDir = getComputedStyle(sb).direction === "rtl" ? 1 : -1;
    sb.addEventListener(
      "touchstart",
      function (e) {
        if (!sb.classList.contains("open")) return;
        sbSX = e.touches[0].clientX;
        sbSY = e.touches[0].clientY;
        sbDrag = false;
        sbWent = 0;
      },
      { passive: true },
    );
    sb.addEventListener(
      "touchmove",
      function (e) {
        if (!sb.classList.contains("open")) return;
        var dx = e.touches[0].clientX - sbSX,
          dy = e.touches[0].clientY - sbSY;
        if (!sbDrag) {
          if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
          sbDrag = true;
          sb.classList.add("sbar-drag");
        }
        sbWent = Math.max(0, dx * sbDir);
        sb.style.transform = "translateX(" + sbWent * sbDir + "px)";
        e.preventDefault();
      },
      { passive: false },
    );
    function sbSwipeEnd() {
      if (!sbDrag) return;
      sbDrag = false;
      sb.classList.remove("sbar-drag");
      sb.style.transform = "";
      if (sbWent > 90) sbShow(false);
    }
    sb.addEventListener("touchend", sbSwipeEnd, { passive: true });
    sb.addEventListener("touchcancel", sbSwipeEnd, { passive: true });

    /* ── THE المنتجات TAB (A-146) ──────────────────────────────────────────────────
       Switching tabs swaps the panes and the foot: browsing mode has no foot at all, shop
       mode shows the go-to-cart total bar. The product list is fetched ONCE per page life,
       on first entry, from the sbar-products section via the Section Rendering API — Liquid
       renders it, so titles and prices arrive locale- and market-correct, unlike
       /products.json. ROOT keeps the English storefront on /en URLs. */
    var sbTabs = $$("[data-sbar-tab]", sb),
      sbPanes = {
        cats: $('[data-sbar-pane="cats"]', sb),
        shop: $('[data-sbar-pane="shop"]', sb),
      },
      sbFoot = $("[data-sbar-foot]", sb),
      sbPlist = $("[data-sbar-products]", sb),
      sbPerr = $("[data-sbar-perr]", sb),
      sbPLoaded = false,
      sbPBusy = false;

    function sbTab(k) {
      sbTabs.forEach(function (t) {
        t.setAttribute("aria-selected", t.dataset.sbarTab === k);
      });
      if (sbPanes.cats) sbPanes.cats.hidden = k !== "cats";
      if (sbPanes.shop) sbPanes.shop.hidden = k !== "shop";
      if (sbFoot) sbFoot.hidden = k !== "shop";
      if (k === "shop") sbLoadProducts();
    }
    sbTabs.forEach(function (t) {
      t.addEventListener("click", function () {
        sbTab(t.dataset.sbarTab);
      });
    });

    function sbLoadProducts() {
      if (sbPLoaded || sbPBusy || !sbPlist) return;
      sbPBusy = true;
      if (sbPerr) sbPerr.hidden = true;
      /* The collection handle comes from the Header section's "Products tab collection"
         setting via data-sbar-src (A-147) — the owner's curated ten, in his sort order.
         encodeURIComponent because this store's handles are Arabic. */
      var src = (sbPanes.shop && sbPanes.shop.dataset.sbarSrc) || "all";
      var rows = [];
      function walk(p) {
        return fetch(
          ROOT +
            "/collections/" +
            encodeURIComponent(src) +
            "?section_id=sbar-products&page=" +
            p,
        )
          .then(function (r) {
            if (!r.ok) throw new Error("sbar-products " + r.status);
            return r.text();
          })
          .then(function (html) {
            var ul = new DOMParser()
              .parseFromString(html, "text/html")
              .querySelector("[data-pages]");
            if (!ul)
              throw new Error("sbar-products: list missing from response");
            rows.push.apply(rows, [].slice.call(ul.children));
            if (p < (Number(ul.dataset.pages) || 1)) return walk(p + 1);
          });
      }
      walk(1)
        .then(function () {
          sbPlist.innerHTML = "";
          rows.forEach(function (li) {
            sbPlist.appendChild(li);
          });
          sbPLoaded = true;
        })
        .catch(function () {
          if (sbPerr) sbPerr.hidden = false; /* the strip IS the retry button */
        })
        .then(function () {
          sbPBusy = false;
        });
    }
    if (sbPerr) sbPerr.addEventListener("click", sbLoadProducts);

    /* The total bar starts at the Liquid-rendered cart total and tracks every add/change via
       the same t3b:cart event the cart drawer already dispatches. */
    var sbTotal = $("[data-sbar-total]", sb);
    if (sbTotal)
      document.addEventListener("t3b:cart", function (e) {
        /* A-304: in local-price markets this element is written by the cart section fetch
         (cdRender) - a KWD write here would fight it. */
        if (T.mktLocal) return;
        if (e.detail && typeof e.detail.total_price === "number") {
          sbTotal.textContent = moneyFromCents(e.detail.total_price);
        }
      });
  })();

  /* PARKED WHEN SETTLED (audit P2-16): this ran a layout read + style write every frame for the
     page's lifetime, for a bar that only moves while the easing chases the scroll position. The
     loop now stops itself once converged and a scroll re-arms it — same pixels on screen, zero
     work while the reader is actually reading. */
  if ($("[data-drip]") && !RM) {
    var dp = $("#drip");
    dp.style.display = "block";
    var cur = 0,
      dripOn = false;
    var dl = function () {
      var max = document.documentElement.scrollHeight - innerHeight;
      var t = max > 0 ? Math.min(1, scrollY / max) : 0;
      cur += (t - cur) * 0.06;
      if (Math.abs(t - cur) < 0.0006) {
        cur = t;
        dripOn = false;
      }
      dp.style.height = cur * 96 + "vh";
      if (dripOn) requestAnimationFrame(dl);
    };
    var dripArm = function () {
      if (!dripOn) {
        dripOn = true;
        requestAnimationFrame(dl);
      }
    };
    addEventListener("scroll", dripArm, { passive: true });
    addEventListener("resize", dripArm);
    dripArm();
  }

  var hv = $("[data-keeper-hive]"),
    fb = $("#flybee"),
    trail = $("#beetrail");
  if (hv && fb && trail && !RM) {
    var lastY = scrollY,
      target = 180,
      head = 180,
      px = 0,
      py = 0,
      tl = 0,
      vis = false;
    var NT = 34,
      pts = [],
      rects = [];
    for (var i = 0; i < NT; i++) {
      var r = document.createElementNS("http://www.w3.org/2000/svg", "rect");
      r.setAttribute("width", "9");
      r.setAttribute("height", "2.6");
      r.setAttribute("rx", "1.3");
      r.setAttribute("fill", "currentColor");
      r.setAttribute("opacity", "0");
      trail.appendChild(r);
      rects.push(r);
    }
    var calcBee = function () {
      var r = hv.getBoundingClientRect();
      var t = scrollY - (r.top + scrollY - innerHeight * 0.6);
      if (t <= 0) {
        vis = false;
        pts.length = 0;
        return;
      }
      var ease = Math.min(1, t / 380);
      var cx = innerWidth * 0.5,
        cy = innerHeight * 0.4;
      var x =
        r.left +
        r.width / 2 +
        (cx - (r.left + r.width / 2)) * ease +
        Math.sin(t / 95) * Math.min(innerWidth * 0.28, 150) * ease;
      var y = r.top + (cy - r.top) * ease + Math.cos(t / 150) * 34 * ease;
      tl = Math.cos(t / 95) * 24;
      px = x - 18;
      py = y - 19;
      vis = true;
      var lp = pts[pts.length - 1];
      if (!lp || Math.hypot(x - lp[0], y - lp[1]) > 17) {
        pts.push([
          x,
          y,
          lp ? (Math.atan2(y - lp[1], x - lp[0]) * 180) / Math.PI : 90,
        ]);
        if (pts.length > NT) pts.shift();
      }
    };
    /* Parked when settled (audit P2-16): this mutated the bee plus 34 SVG rects every frame for
       the page's lifetime — including while the bee was invisible. The bee only moves in response
       to scroll (calcBee is scroll-driven; the loop merely eases the heading), so once the heading
       converges there is nothing left to animate. One more frame paints the final state, the loop
       stops, and the scroll handler re-arms it. */
    var beeOn = false;
    var loop = function () {
      head += (target - head) * 0.14;
      if (Math.abs(target - head) < 0.4) {
        head = target;
        beeOn = false;
      }
      if (vis) {
        fb.style.opacity = 1;
        fb.style.transform =
          "translate(" +
          px +
          "px," +
          py +
          "px) rotate(" +
          (head + tl * (target === 180 ? 1 : -1)) +
          "deg)";
      } else fb.style.opacity = 0;
      for (var i = 0; i < NT; i++) {
        var p = pts[pts.length - 2 - i],
          rc = rects[i];
        if (!vis || !p) {
          rc.setAttribute("opacity", "0");
          continue;
        }
        rc.setAttribute(
          "opacity",
          String(Math.max(0, 0.8 * (1 - i / (NT - 2)))),
        );
        rc.setAttribute(
          "transform",
          "translate(" +
            p[0] +
            " " +
            p[1] +
            ") rotate(" +
            p[2] +
            ") translate(-4.5 -1.3)",
        );
      }
      if (beeOn) requestAnimationFrame(loop);
    };
    var beeArm = function () {
      if (!beeOn) {
        beeOn = true;
        requestAnimationFrame(loop);
      }
    };
    addEventListener(
      "scroll",
      function () {
        var d = scrollY - lastY;
        if (Math.abs(d) > 2) target = d > 0 ? 180 : 0;
        lastY = scrollY;
        calcBee();
        beeArm();
      },
      { passive: true },
    );
    addEventListener("resize", function () {
      calcBee();
      beeArm();
    });
    calcBee();
    beeArm();
  }

  /* Shopify sends money as whole numbers, not decimals - see
     snippets/money-subunit.liquid for what the divisor is and why. This turns
     one of those numbers back into the 3-decimal KD the store displays, in
     Latin digits, and never goes negative. */
  function fmtKD(n, sub) {
    if (!(n > 0)) n = 0;
    var v = n / sub;
    return sub >= 1000 ? v.toFixed(3) : v.toFixed(2) + "0";
  }

  /* ONE money formatter (audit P3: there were three, drifting apart was a matter of time).
     Built on the shop's OWN money_format template — literally `{{amount}}0 KD` on this store; see
     the long note in the search module for why the token and its padding zeros are consumed
     together. Two entry points for the two shapes Shopify hands us, so the ×subunit lives in
     exactly one line each:
       moneyFromCents(2500)      → "25.000 KD"   (/cart.js, /recommendations)
       moneyFromDecimal("6.750") → "6.750 KD"    (/products.json, /collections/*.json)
     The meters keep calling fmtKD directly — they interpolate a bare amount into a locale
     sentence, not a standalone price. */
  var MONEY_SLOT = "__T3B_AMT__";
  var MONEY_FMT = String(T.moneyFormat || "{{amount}}").replace(
    /\{\{\s*amount[^}]*\}\}0*/,
    MONEY_SLOT,
  );
  function moneyTemplate(v) {
    if (v == null || v === "") return "";
    return MONEY_FMT.indexOf(MONEY_SLOT) > -1
      ? MONEY_FMT.replace(MONEY_SLOT, v)
      : String(v);
  }
  function moneyFromCents(cents) {
    return moneyTemplate(fmtKD(cents, Number(T.moneySubunit) || 100));
  }
  function moneyFromDecimal(s) {
    return moneyTemplate(s);
  }
  /* A-389: PUBLISHED for the modules that live outside this closure - today the /search
     page re-render, which had quietly grown a fourth money parser with a narrower regex
     (`{{amount}}0?` instead of `{{amount[^}]*}}0*`). It agreed with this one only
     because the shop's format happens to be `{{amount}}0 KD`; any other amount token
     and /search would have rendered the literal template text while every other surface
     stayed correct. Drifting apart was "a matter of time" per the note above - so there
     is now one implementation and a published handle to it. */
  if (window.T3B) window.T3B.money = moneyFromDecimal;

  /* A-309: the meter's remaining amount, in the visitor's committed currency. The rate
     is the OWNER'S (shop.metafields.custom.market_rates via T.fsRate), rounded UP with a
     2% margin - the meter may over-ask by half a riyal, it may never under-ask and then
     charge for delivery anyway. The fill %% stays on the true KWD subtotal, so "full"
     always means checkout agrees. KWD-display markets keep the exact money format. */
  function fsAmountHtml(cents) {
    var sub = Number(T.moneySubunit) || 100;
    /* T-012 follow-up: per-country store — the cart and the threshold are already in
       the store's own currency, so there is nothing to convert and no approximation
       to pad with the +2% margin (that margin exists because a CONVERTED amount is
       approximate; a native one is exact). Exact amount, locale-aware symbol from
       T.fsSym (mkt-amount: Arabic ر.س / English SAR, mark in both). The fsRate and
       fsStep exports do not exist on these stores. */
    if (T.fsNative) {
      var nn = cents / sub;
      /* Dinar stores (BHD, later OMR) are 3-decimal currencies delivered with two
         decimals; their money format supplies the third with a literal trailing zero
         ("{{amount}}0 BD"). Pad to match, or the meter prints 15.40 beside prices
         reading 15.400. Detected from the shop's own format - same test as
         snippets/mkt-truth.liquid, so Liquid and JS cannot drift. Riyal/dirham
         formats do not match and are unchanged. */
      var pad3 = sub < 1000 && /\}\}\s*0/.test(T.moneyFormat || "");
      var nt = pad3
        ? nn.toFixed(2) + "0"
        : nn === Math.floor(nn)
          ? String(nn)
          : nn.toFixed(2);
      return '<b class="fsamt">' + nt + " " + (T.fsSym || "") + "</b>";
    }
    var r = Number(T.fsRate) || 0;
    if (r > 0) {
      /* A-389: the step is classified in Liquid (T.fsStep) so this and
         announcement-bar.liquid cannot drift. 2 = round up to the nearest half unit,
         20 = to the nearest 0.05 for the dinar-class currencies, where half a unit is
         ~0.40 KD and the over-ask was real money. */
      var step = Number(T.fsStep) || 2;
      var n = Math.ceil((cents / sub) * r * 1.02 * step) / step;
      var txt = n === Math.floor(n) ? String(n) : n.toFixed(step > 2 ? 2 : 1);
      return '<b class="fsamt">' + txt + " " + (T.fsSym || "") + "</b>";
    }
    return '<b class="fsamt">' + moneyFromCents(cents) + "</b>";
  }
  /* One writer for both meters' message lines: picks the almost-there wording past 70%,
     and pulses the amount when it changes so the reader's eye lands on what moved. */
  function fsWriteMsg(msg, pct, cents, awayTpl, closeTpl) {
    var tpl = pct >= 70 && closeTpl ? closeTpl : awayTpl || "";
    var html = tpl.replace("[amount]", fsAmountHtml(cents));
    if (msg.dataset.prev === html) return;
    msg.innerHTML = html;
    msg.dataset.prev = html;
    var amt = msg.querySelector(".fsamt");
    if (amt && !RM) {
      amt.classList.remove("tick");
      void amt.offsetWidth;
      amt.classList.add("tick");
    }
  }

  /* Top-of-page free delivery meter (announcement bar). Absent on the cart
     page and when the bar is set to plain text, so every use is guarded. */
  var topFS = $("[data-top-fs]");

  function renderTopFS(totalRaw) {
    if (!topFS) return;
    var sub = Number(T.moneySubunit) || 100;
    var th = Number(T.freeShippingThreshold) || 30 * sub;
    var pct = th > 0 ? Math.min(100, (totalRaw / th) * 100) : 100;
    var fill = $("[data-top-fs-fill]", topFS);
    var bee = $("[data-top-fs-bee]", topFS);
    var msg = $("[data-top-fs-msg]", topFS);
    if (fill) fill.style.width = pct + "%";
    /* A-519: centred on the end of the honey line, stopping just before the hive */
    if (bee)
      bee.style.insetInlineStart =
        "clamp(0px,calc(" + pct + "% - 12px),calc(100% - 54px))";
    if (msg) {
      if (pct >= 100) {
        msg.textContent = topFS.dataset.doneText || "";
        delete msg.dataset.prev;
      } else {
        fsWriteMsg(
          msg,
          pct,
          th - totalRaw,
          topFS.dataset.awayTemplate,
          topFS.dataset.closeTemplate,
        );
      }
    }
    topFS.classList.toggle("done", pct >= 100);
  }

  if (topFS) renderTopFS(Number(topFS.dataset.total) || 0);

  /* Last known cart count, seeded from the server-rendered value. announceCart() compares against
     it to decide whether anything actually changed, so it must be updated wherever the badge is. */
  var lastCartCount = Number(T.cartCount) || 0;

  function setBadge(n) {
    lastCartCount = Number(n) || 0;
    var i = $(".cartb i");
    if (!i) return;
    i.textContent = n;
    i.classList.add("bump");
    setTimeout(function () {
      i.classList.remove("bump");
    }, 240);
  }

  /* The cart icon gets shoved when the bee lands on it — the owner wanted "a bee pushing a cart",
     and this is where that idea works. As a 20px glyph two objects and their relationship collapse
     into a smudge; as an event, at the moment the customer is already watching, it reads.

     The class is removed and re-added with a forced reflow between, because adding a class that is
     already present restarts nothing — without the reflow the second of two quick adds plays no
     animation at all. */
  function nudgeCart(cart) {
    if (!cart || RM) return;
    cart.classList.remove("nudge");
    void cart.offsetWidth;
    cart.classList.add("nudge");
    setTimeout(function () {
      cart.classList.remove("nudge");
    }, 620);
  }

  /* The cart keeps nudging every 2s while it holds something — the owner's call, 2026-08-05.
   *
   * Three conditions, and each is doing a job:
   *
   *   - NEVER under prefers-reduced-motion. A permanently animating element in a sticky header is
   *     precisely what that setting exists to stop. This one is not a preference.
   *   - NOT while the tab is hidden. Animating a header nobody is looking at burns battery for
   *     nothing. Checked per tick rather than via visibilitychange listeners, so there is no
   *     listener to leak and no resume path to get wrong.
   *   - ONLY while the cart has items. An empty cart nudging itself is advertising nothing.
   *
   * 2000ms deliberately exceeds the 620ms class-removal above; any shorter and the class is still
   * present when the next cycle fires, so the animation never restarts and the whole thing dies
   * silently after one play.
   */
  var nudgeLoop = null;
  function stopNudgeLoop() {
    if (nudgeLoop) {
      clearInterval(nudgeLoop);
      nudgeLoop = null;
    }
  }
  function startNudgeLoop() {
    if (RM) return;
    stopNudgeLoop();
    nudgeLoop = setInterval(function () {
      if (document.hidden) return;
      var cart = $(".cartb");
      if (!cart) {
        stopNudgeLoop();
        return;
      }
      var badge = cart.querySelector("i");
      if (!badge || (Number(badge.textContent) || 0) < 1) {
        stopNudgeLoop();
        return;
      }
      nudgeCart(cart);
    }, 2000);
  }
  /* Also on arrival at any page with something already in the cart. Without this the nudging only
     ever happens on the page where the item was added, and stops the moment the customer navigates
     — which is the opposite of what it is for. */
  if (lastCartCount > 0) startNudgeLoop();

  function flyToCart(fromEl, done) {
    var cart = $(".cartb");
    if (!cart || RM) {
      if (done) done();
      return;
    }
    var r1 = fromEl.getBoundingClientRect(),
      r2 = cart.getBoundingClientRect();
    var el = document.createElement("div");
    el.className = "cartbee";
    el.innerHTML = soloSVG();
    document.body.appendChild(el);
    var x0 = r1.left + r1.width / 2,
      y0 = r1.top,
      x1 = r2.left + r2.width / 2,
      y1 = r2.top + r2.height / 2;
    /* Fallback must match `atc_bee_ms`'s default in settings_schema.json. Two numbers claiming to
       be the same default is a bug waiting for whoever changes one of them. */
    var D = Math.max(400, Number(T.beeMs) || 1000);
    var cx = (x0 + x1) / 2,
      cy = Math.min(y0, y1) - 130,
      t0 = performance.now(),
      lastD = [x0, y0];
    (function step(n) {
      var raw = Math.min(1, (n - t0) / D);
      var t = raw * raw * (3 - 2 * raw),
        u = 1 - t;
      var x = u * u * x0 + 2 * u * t * cx + t * t * x1,
        y = u * u * y0 + 2 * u * t * cy + t * t * y1;
      var dx = 2 * u * (cx - x0) + 2 * t * (x1 - cx),
        dy = 2 * u * (cy - y0) + 2 * t * (y1 - cy);
      el.style.transform =
        "translate(" +
        (x - 13) +
        "px," +
        (y - 13) +
        "px) rotate(" +
        ((Math.atan2(dy, dx) * 180) / Math.PI + 90) +
        "deg)";
      if (Math.hypot(x - lastD[0], y - lastD[1]) > 26) {
        var d = document.createElement("i");
        d.className = "flydash";
        d.style.transform =
          "translate(" +
          (x - 4) +
          "px," +
          (y - 1) +
          "px) rotate(" +
          (Math.atan2(dy, dx) * 180) / Math.PI +
          "deg)";
        document.body.appendChild(d);
        setTimeout(function () {
          d.remove();
        }, 650);
        lastD = [x, y];
      }
      if (t < 1) requestAnimationFrame(step);
      else {
        el.remove();
        nudgeCart(cart);
        startNudgeLoop();
        if (done) done();
      }
    })(t0);
  }

  /* One transient message surface for actions that have no error element of their own — a failed
     add-to-cart above all, which used to look like "the button did nothing". Bottom of the screen,
     where the eye already is after tapping an add button; auto-clears; role=status so assistive
     tech hears it without being interrupted. */
  var toastEl = null,
    toastTimer = null;
  function showToast(msg) {
    msg = msg || (T.strings && T.strings.cartError) || "";
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement("p");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove("on");
    }, 5000);
  }

  /* IN FLIGHT = IGNORED. Without the guard a double-click or double-Enter fired two POSTs and
     quantity 2 landed in the cart (audit P2-10). One add at a time is plenty for a honey shop. */
  var atcBusy = false;
  function ajaxAdd(variantId, qty, fromEl) {
    if (atcBusy) {
      /* A-389: the swallowed tap used to be COMPLETELY silent - it returned before
         touching the DOM, so there was no pulse, no toast and nothing announced. Tap
         jar A then jar B half a second later and B did visibly nothing. Acknowledge
         the press even though the add is refused; worst case the customer taps again
         a moment later and it works. Worst affected were reduced-motion visitors,
         for whom the bee animation that normally fills that second never runs. */
      if (fromEl && fromEl.classList) {
        fromEl.classList.add("atcpress");
        setTimeout(function () {
          fromEl.classList.remove("atcpress");
        }, 380);
      }
      return Promise.resolve(null);
    }
    atcBusy = true;
    /* Zero-latency acknowledgment (A-147) plus the HONEY FILL (A-162): the pulse fires on
       TAP, and the button starts flooding with honey — the network wait itself becomes the
       show. The fill clears on settle: success hands over to the confirmation pop and the
       bee; failure strips it instantly so an error never wears a success costume. */
    if (fromEl && fromEl.classList) {
      fromEl.classList.add("atcpress", "atcfill");
      setTimeout(function () {
        fromEl.classList.remove("atcpress");
      }, 380);
    }
    var reqT =
      performance.now(); /* A-369: request-start stamp, rides into t3b:cart */
    /* A-389: THE SAME GUARD cdSend HAS CARRIED SINCE AUDIT B-14, which this path
       never got. A request that STALLS - a connection that looks alive but blackholes
       packets, i.e. a cell handover or a captive portal - is not an error, so neither
       handler below ran and `atcBusy` stayed true for the life of the page. Every
       later Add then returned null before touching the DOM: no animation, no toast,
       and no native-form fallback, because the submit handler had already called
       preventDefault. Meanwhile the first button kept `.atcfill`, whose animation is
       `forwards`, so it sat as a solid honey block reading as SUCCESS. Only a reload
       recovered it. Collection and home pages had no escape hatch at all (the PDP's
       Buy Now runs its own separate request). */
    var atcAbort =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    var atcAbortTimer = atcAbort
      ? setTimeout(function () {
          atcAbort.abort();
        }, 10000)
      : null;
    return fetch(ROOT + "/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      signal: atcAbort ? atcAbort.signal : undefined,
      /* A-304 speed rule (owner: "no delays allowed"): the SAME add request brings back
         the server-rendered drawer section - Shopify renders it into this response, so
         local-currency lines and totals cost zero additional round trips. */
      body: JSON.stringify({
        id: Number(variantId),
        quantity: qty || 1,
        sections: "cart-drawer-lines",
      }),
    })
      .then(function (r) {
        if (!r.ok) {
          /* Shopify's 422 carries {description|message}, already localized — a stock cap, mostly.
           Shown, not swallowed: the old path navigated away and the reason was never seen. The
           marker object keeps HANDLED failures out of the callers' network-fallback catch. */
          return r.json().then(
            function (err) {
              throw {
                handled: true,
                msg: err && (err.description || err.message),
              };
            },
            function () {
              throw { handled: true };
            },
          );
        }
        /* THE BEE LAUNCHES HERE — one round trip earlier than it used to (A-147). The add is
         already confirmed by this 200, so the flight is honest; the /cart.js re-fetch runs
         DURING the ~1s flight instead of before it, and the badge still lands with the bee.
         The re-fetch always wins that race in practice; if it somehow hasn't, the badge
         update simply waits for whichever finishes last. */
        var flight = new Promise(function (res) {
          flyToCart(fromEl, res);
        });
        return r
          .json()
          .then(function (added) {
            return fetch(ROOT + "/cart.js")
              .then(function (c) {
                return c.json();
              })
              .then(function (cart) {
                /* The rendered section rides the cart object into t3b:cart; the drawer listener
             applies it instead of fetching. */
                if (added && added.sections) cart.__sections = added.sections;
                cart.__reqT = reqT;
                return cart;
              });
          })
          .then(function (cart) {
            /* SUBTOTAL for the meter, everywhere: Shopify's free-delivery discount triggers on the
           subtotal, and mixed bases put two contradicting meters on one screen (audit P1-5). */
            flight.then(function () {
              setBadge(cart.item_count);
              renderTopFS(cart.items_subtotal_price);
            });
            /* Announced rather than called directly. The cart bar is defined further down this same
           IIFE, and an event keeps the two from depending on declaration order — which is exactly
           the kind of coupling that produced the `lastY` collision. Anything else that changes
           the cart can raise the same event and the bar will follow. */
            document.dispatchEvent(
              new CustomEvent("t3b:cart", { detail: cart }),
            );
            return cart;
          });
      })
      .then(
        function (v) {
          clearTimeout(atcAbortTimer);
          atcBusy = false;
          if (fromEl && fromEl.classList) {
            fromEl.classList.remove("atcfill");
            fromEl.classList.add("atcdone");
            setTimeout(function () {
              fromEl.classList.remove("atcdone");
            }, 700);
          }
          return v;
        },
        function (e) {
          clearTimeout(atcAbortTimer);
          atcBusy = false;
          /* Strip the honey fill on EVERY failure path, the abort included - a button
             left mid-fill is the costume the A-389 note above describes. */
          if (fromEl && fromEl.classList) fromEl.classList.remove("atcfill");
          if (e && e.handled) {
            showToast(e.msg);
            return null;
          }
          /* An abort reaches here as a plain AbortError - deliberately NOT `handled`,
             so it rethrows and the caller's native fallback (f.submit() /
             location.href) still runs. A stalled tap ends on the real product form
             rather than nowhere. */
          throw e; /* genuine network failure: let the caller's native fallback run */
        },
      );
  }
  document.addEventListener("submit", function (ev) {
    var f = ev.target.closest("form[data-atc-form]");
    if (!f) return;
    ev.preventDefault();
    var id = f.querySelector("[name=id]").value;
    var q = f.querySelector("[name=quantity]");
    var btn = f.querySelector("[type=submit]");
    /* The native fallback runs ONLY on network failure now. A 422 is handled inside ajaxAdd with
       a visible message — f.submit() used to land it on the retired cart page, which bounced
       straight back and swallowed the one sentence that explained the failure. */
    ajaxAdd(
      id,
      q ? Math.max(1, Math.round(Number(q.value) || 1)) : 1,
      btn || f,
    ).catch(function () {
      f.submit();
    });
  }, true);
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-quick-add]");
    if (!b || b.disabled) return;
    ev.preventDefault();
    /* The sticky bar sits NEXT TO a form whose quantity stepper it ignored — pick 3, tap the
       sticky button, get 1 (audit P3). It now reads the same input the form submits. Card and
       drawer quick-adds have no stepper and stay at 1. */
    var qty = 1;
    if (b.closest(".stickyatc")) {
      var qi = $("form[data-atc-form] [name=quantity]");
      if (qi) qty = Math.max(1, Math.round(Number(qi.value) || 1));
    }
    /* Network-failure fallback goes to the PRODUCT page — somewhere the customer can act — never
       to /cart, which no longer exists as a destination. */
    ajaxAdd(b.dataset.quickAdd, qty, b).catch(function () {
      if (b.dataset.url) location.href = b.dataset.url;
    });
  });

  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-qty-step]");
    if (!b) return;
    var input = b.parentElement && b.parentElement.querySelector("input");
    if (!input) return; /* A-257: was an unguarded deref */
    var step = Number(b.dataset.qtyStep) || 0; /* A-257: empty attr was NaN */
    var v = Math.max(
      Number(input.min) || 1,
      Math.round(Number(input.value) || 1) + step,
    );
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  var fsWasDone = null;

  /* EVERY `.fsbar`, not `#fsbar`. There are now two meters — the cart page's and the drawer's — and
     an ID can only ever match the first one in the document, which would leave the drawer's copy
     frozen at whatever it rendered with. Querying by class and reading each bar's own parts
     relatively also means a third meter could be dropped anywhere and would simply work. */
  function renderFS(totalRaw) {
    var bars = $$(".fsbar");
    if (!bars.length) return;
    var sub = Number(T.moneySubunit) || 100;
    var th = Number(T.freeShippingThreshold) || 30 * sub;
    var pct = Math.min(100, (totalRaw / th) * 100);
    var unlocked = pct >= 100;

    bars.forEach(function (fsb) {
      var pctEl = $(".fspct", fsb),
        fill = $(".btfill", fsb),
        bee = $(".btbee", fsb),
        msg = $(".fsmsg", fsb);
      /* never show a rounded 100% while the bar still says "x away" */
      if (pctEl)
        pctEl.textContent =
          (unlocked ? 100 : Math.min(99, Math.round(pct))) + "%";
      if (fill) fill.style.width = pct + "%";
      if (bee)
        bee.style.insetInlineStart =
          "clamp(0px,calc(" + pct + "% - 14px),calc(100% - 62px))";
      if (!msg) return;
      if (unlocked) {
        msg.textContent = T.strings.freeUnlocked;
        delete msg.dataset.prev;
        fsb.classList.add("done");
      } else {
        fsb.classList.remove("done");
        fsWriteMsg(
          msg,
          pct,
          th - totalRaw,
          String(msg.dataset.template || ""),
          msg.dataset.closeTemplate,
        );
      }
    });

    /* The celebration fires once per crossing, on the first visible bar only — two bees bursting
       out of two meters for one event reads as a glitch, not a flourish. */
    if (unlocked) {
      /* The first VISIBLE bar, not bars[0]: with the drawer closed, its meter is display:none and
         its rect is all zeros — the celebration bee orbited coordinate (0,0) in the page corner
         (audit P3). offsetParent is null for a hidden element; no visible meter, no celebration. */
      var visBar = null;
      bars.forEach(function (b) {
        if (!visBar && b.offsetParent !== null) visBar = b;
      });
      if (fsWasDone === false && !RM && visBar) celebrate(visBar);
      fsWasDone = true;
    } else {
      fsWasDone = false;
    }
  }
  function celebrate(fsb) {
    var r = fsb.getBoundingClientRect();
    var el = document.createElement("div");
    el.className = "loopbee";
    el.innerHTML = soloSVG();
    document.body.appendChild(el);
    var t0 = performance.now(),
      D = 1100,
      cx = r.left + r.width / 2,
      cy = r.top - 6;
    (function step(n) {
      var t = Math.min(1, (n - t0) / D);
      el.style.transform =
        "translate(" +
        (cx + (t - 0.5) * r.width * 0.5 - 13) +
        "px," +
        (cy - Math.sin(t * Math.PI * 2) * 30 - 13) +
        "px) rotate(" +
        (Math.cos(t * Math.PI * 2) * 40 + 90) +
        "deg)";
      if (t < 1) requestAnimationFrame(step);
      else el.remove();
    })(t0);
  }
  /* The theme's only live region. Announces cart changes to screen readers, which previously got
     nothing at all — add, quantity change and removal were entirely silent.

     ⚠ THIS FUNCTION OUTLIVED THE MODULE THAT OWNED IT. It was written for the cart page's
     swapCart, and when that page was retired (~200 lines of dead cart-page JS deleted around it —
     swapCart, pushCartChange, queueCartChange, the data-line-* listeners), deleting it too would
     have made every drawer add, change and removal silent to assistive tech again — the exact
     regression #t3b-live was created to fix. It is called from cdChange and the t3b:cart listener
     now; prevCount must be captured BEFORE setBadge, which is what updates lastCartCount.

     Two deliberate choices:
     - It announces only when the item count actually CHANGED. Firing on every render turns the
       region into noise, and a noisy live region is one users switch off.
     - It clears the node before writing. Assistive tech does not re-announce identical text, so
       removing two items in a row would otherwise be announced once. */
  function announceCart(cart, prevCount) {
    var region = document.getElementById("t3b-live");
    if (!region) return;
    var n =
      cart && typeof cart.item_count === "number" ? cart.item_count : null;
    if (n === null || n === prevCount) return;

    var strings = (T && T.strings) || {};
    var msg;
    if (n === 0 || n < prevCount) {
      msg = strings.itemRemoved || "";
    } else {
      msg = (strings.cartUpdated || "").replace("__n__", String(n));
    }
    if (!msg) return;

    region.textContent = "";
    setTimeout(function () {
      region.textContent = msg;
    }, 60);
  }

  /* CERTIFICATIONS DECK — human hands only.

     The auto-drift is GONE, at the owner's instruction and on his observation (recorded in
     memory: never guess): the flashing on his phones began when this section was created, and
     the drift — a programmatic animation firing every 3.4s — is the one mechanism that existed
     in every failing version of it, scroller and deck alike. Whether the flash came from drift
     colliding with human gestures or from its own repeating steps, removing it deletes both
     candidates. Nothing in this section moves unless a person moves it.

     The drag is DIRECT MANIPULATION — the feel the owner described from the first version:
     "like I can hold a card and move it left and right." The front card follows the finger
     (dampened, clamped); past the threshold on release it steps, short of it it springs back.
     touch-action:pan-y keeps vertical page scrolling native. The circle is modulo; the counter
     announces per step; hidden cards are aria-hidden. */
  $$("[data-certfan]").forEach(function (fan) {
    var cards = $$(".certcard", fan);
    var n = cards.length;
    if (!n) return;
    var statusEl = fan.parentElement
      ? $("[data-cert-status]", fan.parentElement)
      : null;
    var tpl = fan.getAttribute("data-counter-template") || "";
    var rtl = getComputedStyle(fan).direction === "rtl";
    var cur = Math.floor(
      n / 2,
    ); /* the middle block starts front — HACCP, per the owner */

    /* Writes only what CHANGED — per step, at most four cards mutate; the resting eight are not
       touched at all (the audit flagged the old version invalidating all eleven every step). */
    function apply() {
      var next = (cur + 1) % n,
        prev = (cur - 1 + n) % n;
      cards.forEach(function (c, i) {
        var want =
          i === cur
            ? "is-front"
            : n > 1 && i === (rtl ? next : prev)
              ? "is-left"
              : n > 2 && i === (rtl ? prev : next)
                ? "is-right"
                : "";
        if (c.__pos !== want) {
          if (c.__pos) c.classList.remove(c.__pos);
          if (want) c.classList.add(want);
          c.__pos = want;
          c.setAttribute("aria-hidden", want === "is-front" ? "false" : "true");
        }
      });
      if (statusEl && tpl) {
        statusEl.textContent = tpl
          .replace("__A__", String(cur + 1))
          .replace("__B__", String(n));
      }
    }

    /* Burst swipes SNAP: a step that begins while the previous one is still animating commits
       instantly (the .snapstep class kills transitions for it), so animation load cannot stack —
       the one accumulating cost this section had left. A lone swipe keeps its full glide. */
    /* -Infinity, not 0: performance.now() starts near zero at page load, and a first swipe inside
       the first 460ms would have read as a "burst" and wrongly snapped — the harness caught it. */
    var lastStep = -Infinity,
      snapClear = null;
    function step(delta) {
      var now = performance.now();
      if (now - lastStep < 460) {
        fan.classList.add("snapstep");
        clearTimeout(snapClear);
        snapClear = setTimeout(function () {
          fan.classList.remove("snapstep");
        }, 80);
      }
      lastStep = now;
      cur = (cur + delta + n) % n;
      apply();
    }
    apply();

    /* The live drag. Pointer capture keeps the gesture even when the finger wanders off the
       card; the inline transform overrides the class transform while .is-dragging suppresses
       the transition, and clearing both on release hands the card back to its class state —
       which either springs it home or (after step()) animates it to its new position. */
    var dragEl = null,
      downX = null,
      downY = null,
      dragging = false;
    fan.addEventListener(
      "pointerdown",
      function (e) {
        downX = e.clientX;
        downY = e.clientY;
        dragging = false;
        dragEl = cards[cur];
        if (fan.setPointerCapture) {
          try {
            fan.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
      },
      { passive: true },
    );
    fan.addEventListener(
      "pointermove",
      function (e) {
        if (downX === null || !dragEl) return;
        var dx = e.clientX - downX,
          dy = e.clientY - downY;
        if (!dragging) {
          if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy))
            return; /* not ours (yet) */
          dragging = true;
          dragEl.classList.add("is-dragging");
        }
        /* Dampened and clamped: the card comes with the hand but resists leaving. */
        var pull = Math.max(-120, Math.min(120, dx * 0.6));
        dragEl.style.transform = "translateX(calc(-50% + " + pull + "px))";
      },
      { passive: true },
    );
    function release(e) {
      if (downX === null) return;
      var dx = (e.clientX != null ? e.clientX : downX) - downX;
      var dy = (e.clientY != null ? e.clientY : downY) - downY;
      var was = dragging;
      downX = downY = null;
      dragging = false;
      if (dragEl) {
        dragEl.classList.remove("is-dragging");
        dragEl.style.transform = "";
        dragEl = null;
      }
      if (!was) return; /* a tap: nothing moves */
      if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy))
        return; /* short pull: springs back */
      var fromRight = dx < 0; /* dragged left → right card comes */
      step(fromRight === rtl ? -1 : 1);
    }
    fan.addEventListener("pointerup", release, { passive: true });
    fan.addEventListener("pointercancel", release, { passive: true });

    /* Side cards are tappable invitations: bring that card forward. */
    fan.addEventListener("click", function (e) {
      var c = e.target.closest && e.target.closest(".certcard");
      if (!c) return;
      if (c.classList.contains("is-left")) step(rtl ? 1 : -1);
      else if (c.classList.contains("is-right")) step(rtl ? -1 : 1);
    });

    /* Keyboard, mapped to what the arrows mean visually. */
    fan.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var toRight = e.key === "ArrowRight";
      step(toRight === rtl ? 1 : -1);
    });
  });

  /* ── MANUKA GRADE DECK (A-151) ─────────────────────────────────────────────────
     The certifications deck's exact mechanics — human hands only, burst-snap, dampened
     drag, RTL-mapped keys — re-scoped to its own hooks so neither deck can regress the
     other, plus ONE addition: every card owns a detail panel below the deck (checklist,
     price, buy button, certificate link — all Liquid-rendered, so locale and market
     formatting are free), and stepping the deck swaps the visible panel by index. The
     panels toggle [hidden]; nothing is re-rendered or fetched. */
  $$("[data-mnk-deck]").forEach(function (fan) {
    var cards = $$(".mnkd-card", fan);
    var n = cards.length;
    if (!n) return;
    var root = fan.closest(".mnkdeck") || fan.parentElement;
    var panels = $$("[data-mnk-panel]", root);
    var statusEl = $("[data-mnk-status]", root);
    var tpl = fan.getAttribute("data-counter-template") || "";
    var rtl = getComputedStyle(fan).direction === "rtl";
    var cur = Math.floor(n / 2);

    function apply() {
      var next = (cur + 1) % n,
        prev = (cur - 1 + n) % n;
      cards.forEach(function (c, i) {
        var want =
          i === cur
            ? "is-front"
            : n > 1 && i === (rtl ? next : prev)
              ? "is-left"
              : n > 2 && i === (rtl ? prev : next)
                ? "is-right"
                : "";
        if (c.__pos !== want) {
          if (c.__pos) c.classList.remove(c.__pos);
          if (want) c.classList.add(want);
          c.__pos = want;
          c.setAttribute("aria-hidden", want === "is-front" ? "false" : "true");
        }
      });
      panels.forEach(function (p, i) {
        p.hidden = i !== cur;
      });
      if (statusEl && tpl) {
        statusEl.textContent = tpl
          .replace("__A__", String(cur + 1))
          .replace("__B__", String(n));
      }
    }

    var lastStep = -Infinity,
      snapClear = null;
    function step(delta) {
      var now = performance.now();
      if (now - lastStep < 460) {
        fan.classList.add("snapstep");
        clearTimeout(snapClear);
        snapClear = setTimeout(function () {
          fan.classList.remove("snapstep");
        }, 80);
      }
      lastStep = now;
      cur = (cur + delta + n) % n;
      apply();
    }
    apply();

    var dragEl = null,
      downX = null,
      downY = null,
      dragging = false;
    fan.addEventListener(
      "pointerdown",
      function (e) {
        downX = e.clientX;
        downY = e.clientY;
        dragging = false;
        dragEl = cards[cur];
        if (fan.setPointerCapture) {
          try {
            fan.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
      },
      { passive: true },
    );
    fan.addEventListener(
      "pointermove",
      function (e) {
        if (downX === null || !dragEl) return;
        var dx = e.clientX - downX,
          dy = e.clientY - downY;
        if (!dragging) {
          if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
          dragging = true;
          dragEl.classList.add("is-dragging");
        }
        var pull = Math.max(-120, Math.min(120, dx * 0.6));
        dragEl.style.transform = "translateX(calc(-50% + " + pull + "px))";
      },
      { passive: true },
    );
    function release(e) {
      if (downX === null) return;
      var dx = (e.clientX != null ? e.clientX : downX) - downX;
      var dy = (e.clientY != null ? e.clientY : downY) - downY;
      var was = dragging;
      downX = downY = null;
      dragging = false;
      if (dragEl) {
        dragEl.classList.remove("is-dragging");
        dragEl.style.transform = "";
        dragEl = null;
      }
      if (!was) return;
      if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy)) return;
      var fromRight = dx < 0;
      step(fromRight === rtl ? -1 : 1);
    }
    fan.addEventListener("pointerup", release, { passive: true });
    fan.addEventListener("pointercancel", release, { passive: true });

    fan.addEventListener("click", function (e) {
      var c = e.target.closest && e.target.closest(".mnkd-card");
      if (!c) return;
      if (c.classList.contains("is-left")) step(rtl ? 1 : -1);
      else if (c.classList.contains("is-right")) step(rtl ? -1 : 1);
    });

    fan.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var toRight = e.key === "ArrowRight";
      step(toRight === rtl ? 1 : -1);
    });

    /* The two arrow buttons flanking the deck: visual direction, mapped like the keys. */
    $$("[data-mnk-arrow]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        var toRight = b.dataset.mnkArrow === "right";
        step(toRight === rtl ? 1 : -1);
      });
    });
  });

  /* ── MANUKA BENEFITS WHEEL (A-152) ────────────────────────────────────────────────
     Six numbered buttons on hexagon vertices; tapping one swaps the center line and the
     detail paragraph below — all Liquid-rendered, toggled by [hidden], nothing rebuilt. */
  $$("[data-mnk-wheel]").forEach(function (hex) {
    var root = hex.closest(".mnkwheel") || hex.parentElement;
    var nodes = $$("[data-mnk-node]", hex);
    var centers = $$("[data-mnk-wpanel]", hex);
    var details = $$("[data-mnk-wdetail]", root);
    if (!nodes.length) return;
    nodes.forEach(function (node, i) {
      node.addEventListener("click", function () {
        nodes.forEach(function (n, j) {
          n.setAttribute("aria-pressed", j === i ? "true" : "false");
        });
        centers.forEach(function (p, j) {
          p.hidden = j !== i;
        });
        details.forEach(function (p, j) {
          p.hidden = j !== i;
        });
      });
    });
  });

  /* ── MANUKA FACTS CAROUSEL (A-152) ────────────────────────────────────────────────
     Native scroll-snap does the moving; this module is only the conveniences — arrows
     scroll one card, dots track the scroll position. Without it the track still swipes. */
  $$("[data-mnk-facts]").forEach(function (box) {
    var track = $("[data-mnk-ftrack]", box);
    if (!track) return;
    var items = $$(".mnkf-item", track);
    var dots = $$("[data-mnk-fdots] button", box);
    var n = items.length;
    if (n < 2) return;
    function idx() {
      /* scrollLeft is negative in RTL in modern engines; magnitude over card width. */
      return Math.max(
        0,
        Math.min(
          n - 1,
          Math.round(Math.abs(track.scrollLeft) / track.clientWidth),
        ),
      );
    }
    function paint() {
      var i = idx();
      dots.forEach(function (d, j) {
        d.classList.toggle("on", j === i);
      });
    }
    var raf = null;
    track.addEventListener(
      "scroll",
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          paint();
        });
      },
      { passive: true },
    );
    $$("[data-mnk-fstep]", box).forEach(function (b) {
      b.addEventListener("click", function () {
        var dir = Number(b.dataset.mnkFstep) || 1;
        /* dir is VISUAL (left arrow = -1). In RTL, visual left means forward through the
           list, and scrollBy with a negative x already goes visually left in both modes. */
        track.scrollBy({
          left: dir * track.clientWidth,
          behavior: RM ? "auto" : "smooth",
        });
      });
    });
    dots.forEach(function (d, j) {
      d.addEventListener("click", function () {
        var sign = getComputedStyle(track).direction === "rtl" ? -1 : 1;
        track.scrollTo({
          left: sign * j * track.clientWidth,
          behavior: RM ? "auto" : "smooth",
        });
      });
    });
  });

  /* ── الكويتي INTERACTIVES (A-165) ─────────────────────────────────────────────────
     Four small machines, all state-in-[hidden]/aria — the deck's proven pattern, no
     rebuilding, no loops. */
  /* The Sidr benefits tree (A-178): tap a fruit in the canopy, its panel swaps in below —
     the comb's index-swap mechanic on a different plant. */
  $$("[data-kw-tree]").forEach(function (root) {
    var fruits = $$("[data-kw-fruit]", root),
      panels = $$("[data-kw-leafpanel]", root);
    fruits.forEach(function (f, i) {
      f.addEventListener("click", function () {
        fruits.forEach(function (n, j) {
          n.setAttribute("aria-pressed", j === i ? "true" : "false");
        });
        panels.forEach(function (p, j) {
          p.hidden = j !== i;
        });
      });
    });
  });
  /* The jar anatomy (A-185): hexagon hotspots and card tabs drive the same fixed-size pane
     stack; the comparison bars grow once, when their pane first shows. */
  $$("[data-kw-anatomy]").forEach(function (root) {
    var picks = $$("[data-kwj-pick]", root),
      panes = $$("[data-kwj-pane]", root);
    function go(i) {
      picks.forEach(function (b) {
        b.classList.toggle("on", b.getAttribute("data-kwj-pick") === i);
      });
      panes.forEach(function (p) {
        var on = p.getAttribute("data-kwj-pane") === i;
        p.hidden = !on;
        if (on) {
          var bars = p.querySelector("[data-kwj-bars]");
          if (bars)
            setTimeout(function () {
              bars.classList.add("kwj-go");
            }, 80);
        }
      });
    }
    picks.forEach(function (b) {
      b.addEventListener("click", function () {
        go(b.getAttribute("data-kwj-pick"));
      });
    });
  });
  /* The season dial: phase tabs swap the story below (the needle itself is Liquid-set). */
  $$("[data-kw-dial]").forEach(function (root) {
    var tabs = $$("[data-kw-arc]", root),
      panels = $$("[data-kw-arcpanel]", root);
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        tabs.forEach(function (n, j) {
          n.setAttribute("aria-pressed", j === i ? "true" : "false");
        });
        panels.forEach(function (p, j) {
          p.hidden = j !== i;
        });
      });
    });
  });

  /* The language switcher keeps the query string (audit P3). Liquid cannot see it — request.path
     is all the template has — so the hidden return_to carried the bare path and switching language
     from a filtered collection or a search page dropped the filters and the search terms. Filled in
     at submit time from location.search; without JS the old path-only behaviour remains. */
  /* A-389: the LOCALE MODAL's form was never covered by this. The footer switcher
     (form.langsh) kept the query string and the header flag chip did not, so switching
     language from /search?q=سدر landed on /en/search with the search gone - the exact
     bug this handler exists to prevent, on the more prominent of the two controls. */
  document.addEventListener("submit", function (ev) {
    var f =
      ev.target.closest && ev.target.closest("form.langsh, form.lcm-form");
    if (!f) return;
    var rt = f.querySelector("[name=return_to]");
    if (rt && location.search && rt.value.indexOf("?") === -1)
      rt.value += location.search;
  });

  /* The order note, which lost its home when the cart page was retired: for a gifting-heavy honey
     shop, "gift message / delivery instructions" is not optional. The field lives in the drawer's
     footer now, saved on change. Static markup in the layout, so the value survives every drawer
     re-render — cdRender only redraws the line list. */
  document.addEventListener("change", function (ev) {
    var note =
      ev.target && ev.target.closest && ev.target.closest("[data-cart-note]");
    if (!note) return;
    fetch(ROOT + "/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ note: note.value }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("note save " + r.status);
      })
      .catch(function () {
        /* A-389: this was fire-and-forget - no .then, no .catch. A failed save dropped
           the customer's gift message or delivery instruction with no sign at all, and
           left an unhandled rejection behind it. The note is sometimes the whole point
           of the order in a gifting-heavy honey shop, so it has to fail loudly enough
           to retype. The text stays in the textarea either way. */
        var msg = note.getAttribute("data-err");
        if (msg) showToast(msg);
      });
  });

  /* Real related products. The section renders a generic fallback statically (all it CAN know
     without the recommendations route); this fetches the same section through that route and swaps
     the grid in — only when the answer actually holds products, so a product with no
     recommendations keeps the fallback instead of gaining an empty grid. */
  var recHost = $("[data-rec-url]");
  if (recHost) {
    fetch(recHost.getAttribute("data-rec-url"))
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var fresh = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("[data-rec-grid]");
        var cur = $("[data-rec-grid]", recHost);
        if (!(fresh && cur && fresh.children.length))
          return; /* no recs: section stays hidden (A-253, owner's rule) */
        cur.replaceWith(fresh);
        /* A-253: force-reveal everything inside. The load-time reveal observer never saw
           these swapped-in nodes (the invisible-related bug), and a section unhidden after
           load must not depend on an observer registered while it was display:none. */
        recHost.hidden = false;
        recHost.querySelectorAll(".rv").forEach(function (el) {
          el.classList.add("rvin");
        });
      })
      .catch(function () {
        /* endpoint failed: section simply stays hidden */
      });
  }

  var gal = $("[data-gallery]");
  if (gal)
    gal.addEventListener("click", function (ev) {
      /* A-494: on a touch screen a tap on the main photo zooms in and the next tap zooms back
         out. A mouse keeps the hover zoom (CSS) and is left alone here - there a tap that counts
         as a never-ending hover is exactly what left the photo stuck zoomed on phones. */
      var mainBox = ev.target.closest(".main");
      if (mainBox && gal.contains(mainBox)) {
        if (!matchMedia("(hover: hover) and (pointer: fine)").matches)
          mainBox.classList.toggle("is-zoom");
        return;
      }
      var b = ev.target.closest("[data-thumb]");
      if (!b) return;
      var zoomed = $(".main.is-zoom", gal);
      if (zoomed) zoomed.classList.remove("is-zoom"); /* a new photo starts unzoomed */
      /* Set srcset BEFORE src, and always set it — even to ''. The main image now carries a srcset
       for the LCP, and a stale srcset outranks a freshly-assigned src: swapping src alone would
       leave the previous image on screen and make the thumbnail look broken. */
      var mainImg = $("[data-main-image]", gal);
      mainImg.srcset = b.dataset.thumbSrcset || "";
      mainImg.src = b.dataset.thumb;
      $$("[data-thumb]", gal).forEach(function (t) {
        t.removeAttribute("aria-current");
      });
      b.setAttribute("aria-current", "true");
      /* A-493: the thumbnails are a vertical strip that shows four and three quarters of a
         fifth. A tapped thumbnail that is cut is brought to the middle of the strip - by
         scrolling the STRIP by a measured amount, never scrollIntoView (it would move the
         page). Nothing happens when the strip does not scroll. */
      var strip = b.parentNode;
      if (strip && strip.scrollHeight > strip.clientHeight + 1) {
        var sr = strip.getBoundingClientRect(),
          br = b.getBoundingClientRect();
        strip.scrollBy({
          top: br.top + br.height / 2 - (sr.top + sr.height / 2),
          behavior: RM ? "auto" : "smooth",
        });
      }
    });

  /* A-494: arrows for the thumbnail strip, shown by CSS on desktop only. Each is visible only
     while the strip has more in its direction; a click moves the strip by two thumbnails. */
  var gStrip = gal && $(".thumbs", gal),
    gUp = gal && $("[data-thumbs-up]", gal),
    gDown = gal && $("[data-thumbs-down]", gal);
  if (gStrip && gUp && gDown) {
    var gUpdate = function () {
      var more = gStrip.scrollHeight > gStrip.clientHeight + 1;
      gUp.hidden = !more || gStrip.scrollTop <= 1;
      gDown.hidden =
        !more ||
        gStrip.scrollTop + gStrip.clientHeight >= gStrip.scrollHeight - 1;
    };
    var gStep = function (dir) {
      var t = $("[data-thumb]", gStrip);
      var h = t ? t.getBoundingClientRect().height : 72;
      var g = parseFloat(getComputedStyle(gStrip).rowGap) || 0;
      gStrip.scrollBy({
        top: dir * 2 * (h + g),
        behavior: RM ? "auto" : "smooth",
      });
    };
    gUp.addEventListener("click", function () {
      gStep(-1);
    });
    gDown.addEventListener("click", function () {
      gStep(1);
    });
    var gTimer;
    var gQueue = function () {
      clearTimeout(gTimer);
      gTimer = setTimeout(gUpdate, 80);
    };
    gStrip.addEventListener("scroll", gQueue, { passive: true });
    addEventListener("resize", gQueue);
    gUpdate();
  }

  var nf = $(".news form");
  if (nf)
    nf.addEventListener("submit", function () {
      var btn = nf.querySelector("button[type=submit]");
      if (btn) {
        btn.classList.add("done");
        btn.textContent = T.strings.inTheHive;
      }
    });

  /* ── In-page search ────────────────────────────────────────────────────────────────
   *
   * WHY THE MATCHING IS DONE HERE INSTEAD OF BY SHOPIFY. Measured on this store 2026-08-05:
   * `/search?q=سدر` returned ZERO products while the catalogue is full of "عسل السدر الجبلي" and
   * "عسل السدر الدوعني"; `/search?q=عسل` returned 12. Shopify will not match across the Arabic
   * definite article, so the store's most important word found nothing. Its predictive-search API
   * is no help either — on the Arabic storefront it answers 417 "Unsupported buyer locale".
   *
   * EVERYTHING BELOW IS AN ENHANCEMENT. The header control is a real link to /search and this form
   * is a real GET form; if this code never runs, search still works the old way.
   */
  var sdr = $("[data-search-drawer]");
  if (sdr) {
    var sInput = $("[data-search-input]", sdr),
      sResults = $("[data-search-results]", sdr),
      sStatus = $("[data-search-status]", sdr),
      sAll = $("[data-search-all]", sdr),
      sDrop = $("[data-search-drop]", sdr),
      sClear = $("[data-search-clear]", sdr),
      /* Every name here is prefixed. There is already a `var lastY` in the flying-bee module of
       * this same IIFE, and because `var` is FUNCTION-scoped rather than block-scoped the two were
       * literally one variable — the bee's scroll handler silently overwrote this module's saved
       * scroll offset on every scroll event. That bug survived three attempted fixes because every
       * local signal looked correct. Prefixing is cheap; the collision was not. */
      INDEX = null,
      loading = false,
      tmr = null;

    /* Fold the differences that stop a human's spelling matching a database's. Tashkeel and tatweel
     * are decorative; أ إ آ ٱ are all alef; ة/ه and ى/ي are routinely typed either way; and a
     * shopper may type Arabic-Indic digits even though this catalogue is written in Latin ones. */
    function norm(s) {
      return String(s || "")
        .replace(/[ً-ْٰـ]/g, "")
        .replace(/[أإآٱ]/g, "ا")
        .replace(/ة/g, "ه")
        .replace(/ى/g, "ي")
        .replace(/ؤ/g, "و")
        .replace(/ئ/g, "ي")
        .replace(/[٠-٩]/g, function (d) {
          return String.fromCharCode(d.charCodeAt(0) - 0x0660 + 48);
        })
        .toLowerCase();
    }

    /* The whole point. Indexing the title twice — once as written, once with the leading ال removed
     * from every word — is what makes "سدر" find "السدر" and "برية" find "البرية" with a plain
     * substring test, no stemmer required. */
    function haystack(p) {
      var base = norm(
        [p.title, p.product_type, p.vendor, (p.tags || []).join(" ")].join(" "),
      );
      return base + " " + base.replace(/(^|\s)ال/g, "$1");
    }

    /* `/products.json` gives price as a DECIMAL STRING already — "0.500", not the 50 cents that
     * /cart.js would return. Dividing it by 100 renders every price a hundredfold too small, which
     * is exactly the bug this comment exists to stop someone reintroducing. No arithmetic: wrap the
     * value in the shop's own money template. */
    /* This shop's money_format is literally `{{amount}}0 KD`. That trailing zero is a common
     * Shopify workaround: `{{amount}}` renders TWO decimals and KWD needs three, so the format pads
     * the third by hand. But `/products.json` already returns all three ("10.500"), so substituting
     * naively produced "10.5000 KD" — four decimals. That reached the live page before it was
     * checked. The token AND any padding zeros are therefore consumed together — in the SHARED
     * moneyTemplate at the top of this file now, where all three former implementations were
     * consolidated (audit P3). `money` survives as a local alias so the render code below reads
     * unchanged. */
    var money = moneyFromDecimal;

    function load() {
      if (INDEX || loading) return Promise.resolve();
      loading = true;
      /* A-389: UNHIDE IT. This element ships `hidden` from search-drawer.liquid and
         only run() ever cleared that - and run() returns early when INDEX is null. So
         both this "جارٍ البحث…" and the error message in the catch below were written
         into an invisible element: the customer typed and got a blank white box with
         no explanation at all. */
      sStatus.textContent = sdr.getAttribute("data-str-loading");
      sStatus.hidden = false;
      /* Lazily, on first open only. Fetching the catalogue for every visitor who never searches
       * would be indefensible. */
      return fetch(ROOT + "/products.json?limit=250")
        .then(function (r) {
          if (!r.ok) throw new Error("index fetch failed");
          return r.json();
        })
        .then(function (j) {
          INDEX = (j.products || []).map(function (p) {
            /* A-389: the CHEAPEST available variant, not variants[0] - the same rule the
               drawer's suggestion row uses. Identical today (every product on this store
               is single-variant), but two surfaces deriving one product's price by
               different rules is how they end up disagreeing later. */
            var v = null;
            var cheapest = Infinity;
            (p.variants || []).forEach(function (x) {
              if (x.available === false) return;
              var c = parseFloat(x.price);
              if (isFinite(c) && c < cheapest) {
                cheapest = c;
                v = x;
              }
            });
            v = v || (p.variants || [])[0] || {};
            var img = (p.images || [])[0] || {};
            return {
              title: p.title,
              url: ROOT + "/products/" + p.handle,
              hay: haystack(p),
              price: v.price,
              img: img.src
                ? img.src.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2")
                : null,
            };
          });
        })
        .catch(function () {
          /* NULL, NOT []. An empty array is truthy, so `if (INDEX || loading)` treated one failed
             fetch as a permanently loaded catalogue of zero products — every later query answered
             "no nectar here" for products that exist, for the whole session. Null means untried:
             the next keystroke or focus calls load() again and actually retries. Say so, too,
             rather than leaving "جارٍ البحث…" on screen forever. */
          INDEX = null;
          sStatus.textContent =
            sdr.getAttribute("data-str-error") ||
            sdr.getAttribute("data-str-none");
          sStatus.hidden = false; /* A-389 - see load() above */
        })
        .then(function () {
          loading = false;
        });
    }

    function esc(s) {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    /* Highlighting needs positions that map back to the ORIGINAL title, and `norm()` cannot give
     * them: it REMOVES tashkeel and tatweel, so the normalised string is shorter and every index
     * after the first stripped mark is wrong. `fold()` does only 1:1 substitutions, so its output
     * is the same length as its input and indexOf results line up exactly. If that assumption ever
     * breaks, the caller bails out rather than slicing the title in the wrong place. */
    function fold(s) {
      return String(s || "")
        .replace(/[أإآٱ]/g, "ا")
        .replace(/ة/g, "ه")
        .replace(/ى/g, "ي")
        .replace(/ؤ/g, "و")
        .replace(/ئ/g, "ي")
        .replace(/[٠-٩]/g, function (d) {
          return String.fromCharCode(d.charCodeAt(0) - 0x0660 + 48);
        })
        .toLowerCase();
    }

    /* Escape FIRST, then wrap — never the other way round. The title is store data, but building
     * innerHTML from an unescaped string is the habit that eventually meets a product called
     * `<img onerror=...>`. */
    function mark(title, terms) {
      var f = fold(title);
      if (f.length !== title.length)
        return esc(title); /* alignment lost — show it plain */
      var spans = [];
      terms.forEach(function (t) {
        if (!t) return;
        var from = 0,
          i;
        while ((i = f.indexOf(t, from)) !== -1) {
          spans.push([i, i + t.length]);
          from = i + t.length;
        }
      });
      if (!spans.length) return esc(title);
      spans.sort(function (a, b) {
        return a[0] - b[0];
      });
      var out = "",
        cursor = 0;
      spans.forEach(function (s) {
        if (s[0] < cursor) return; /* overlapping match already covered */
        out +=
          esc(title.slice(cursor, s[0])) +
          "<mark>" +
          esc(title.slice(s[0], s[1])) +
          "</mark>";
        cursor = s[1];
      });
      return out + esc(title.slice(cursor));
    }

    function run() {
      var raw = sInput.value;
      var q = norm(raw).trim();
      if (!q) {
        sResults.innerHTML = "";
        sStatus.textContent = "";
        sStatus.hidden = true;
        sAll.hidden = true;
        return;
      }
      /* A-389: an index that failed to load must SAY so. This returned silently,
         leaving whatever was on screen - usually nothing - so the dropdown was an empty
         white sliver under the bar. The message itself was already written and
         translated; it simply never reached the screen. Enter still falls through to
         the real /search page, so nobody was ever trapped - they just were not told. */
      if (!INDEX) {
        if (!loading) {
          sStatus.textContent =
            sdr.getAttribute("data-str-error") ||
            sdr.getAttribute("data-str-none");
          sStatus.hidden = false;
        }
        return;
      }
      var terms = q.split(/\s+/);
      var hits = INDEX.filter(function (p) {
        for (var i = 0; i < terms.length; i++)
          if (p.hay.indexOf(terms[i]) === -1) return false;
        return true;
      }).slice(0, 12);

      /* ONE count element, visible AND announced. Two separate numbers is how the spoken count
       * ends up disagreeing with the one on screen. */
      sStatus.hidden = false;
      sStatus.innerHTML = hits.length
        ? esc(sdr.getAttribute("data-str-results")).replace(
            "{n}",
            "<b>" + hits.length + "</b>",
          )
        : esc(sdr.getAttribute("data-str-none"));

      if (!hits.length) {
        sResults.innerHTML = "";
        sAll.hidden = true;
        return;
      }
      var fterms = terms.map(fold);
      sResults.innerHTML = hits
        .map(function (p) {
          return (
            '<a class="sdr-hit" href="' +
            esc(p.url) +
            '">' +
            (p.img
              ? '<img src="' +
                esc(p.img) +
                '" alt="" loading="lazy" width="48" height="48">'
              : '<span class="sdr-noimg"></span>') +
            '<span class="sdr-hit-t">' +
            mark(p.title, fterms) +
            "</span>" +
            /* Local-currency markets: /products.json prices are KWD-only - omit the
             price rather than print the wrong currency. (audit T1) */
            (T.mktLocal
              ? ""
              : '<span class="sdr-hit-p">' + esc(money(p.price)) + "</span>") +
            "</a>"
          );
        })
        .join("");
      cursor = -1;
      sAll.href =
        sdr.getAttribute("data-search-url") +
        "?q=" +
        encodeURIComponent(raw) +
        "&type=product";
      sAll.hidden = false;
    }

    /* Arrow keys through the results, Enter to open the highlighted one. This is the half of the
     * request that is actually about usability: a search you can drive from the keyboard without
     * reaching for the mouse. `aria-selected` carries the state to assistive tech, and the active
     * row is scrolled into view within the results list only — never the page. */
    var cursor = -1;
    function moveCursor(step) {
      var rows = $$(".sdr-hit", sResults);
      if (!rows.length) return;
      if (cursor > -1 && rows[cursor])
        rows[cursor].classList.remove("is-active");
      cursor += step;
      if (cursor < 0) cursor = rows.length - 1;
      if (cursor >= rows.length) cursor = 0;
      rows[cursor].classList.add("is-active");
      rows[cursor].scrollIntoView({ block: "nearest" });
    }

    /* No open/close, no scroll lock, no scroll restore. The bar is always on screen, so there is
     * nothing to overlay and nothing to put back — the whole `position:fixed` body dance is gone,
     * and with it the `lastY` collision and the two false diagnoses it produced. The dropdown just
     * shows and hides. */
    function showDrop(on) {
      sDrop.hidden = !on;
      sInput.setAttribute("aria-expanded", on ? "true" : "false");
    }

    sInput.setAttribute("role", "combobox");
    sInput.setAttribute("aria-expanded", "false");
    sInput.setAttribute("aria-autocomplete", "list");

    function onType() {
      sClear.hidden = !sInput.value;
      load().then(function () {
        run();
        showDrop(!!sInput.value.trim());
      });
    }

    sInput.addEventListener("input", function () {
      clearTimeout(tmr);
      tmr = setTimeout(onType, 120);
    });
    sInput.addEventListener("focus", function () {
      if (sInput.value.trim()) {
        load().then(function () {
          run();
          showDrop(true);
        });
      }
    });

    sClear.addEventListener("click", function () {
      sInput.value = "";
      sClear.hidden = true;
      run();
      showDrop(false);
      sInput.focus();
    });

    /* No backdrop to click any more, so dismissal is an outside click on the document. Guarded by
     * `contains` so clicking inside the bar or a result never closes it mid-interaction. */
    document.addEventListener("click", function (e) {
      if (!sDrop.hidden && !sdr.contains(e.target)) showDrop(false);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !sDrop.hidden) {
        showDrop(false);
        sInput.focus();
      }
    });

    sInput.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        moveCursor(1);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        moveCursor(-1);
      } else if (e.key === "Enter") {
        var rows = $$(".sdr-hit", sResults);
        /* Only hijack Enter when a row is highlighted. Otherwise it falls through to the form and
           lands on the real /search page, which stays linkable and is the no-JS path. */
        if (cursor > -1 && rows[cursor]) {
          e.preventDefault();
          window.location.href = rows[cursor].href;
        }
      }
    });
  }

  /* ── Cart bar + drawer ─────────────────────────────────────────────────────────────
   *
   * A slim bar once the cart holds something; tapping it raises the whole cart. Two ways out,
   * because the owner asked for leaving the cart to be as easy as opening it.
   *
   * EVERY NAME HERE IS PREFIXED `cd`. This file is one long IIFE where `var` is function-scoped,
   * and a reused name silently overwrote another module's state once already (A-084, `lastY`).
   * The prefix is not style; it is the fix for a bug that survived three attempts.
   *
   * NO BODY SCROLL LOCK. The `position:fixed` body technique was deleted in A-087 for good reason —
   * it collapsed the document and needed a fragile scroll restore. The drawer scrolls internally
   * with `overscroll-behavior`, which is enough and cannot strand the reader at the top of the page.
   */
  var cdRoot = $("[data-cart-drawer]");
  if (cdRoot) {
    var cdBar = $("[data-cart-bar]", cdRoot),
      cdPanel = $("[data-cart-panel]", cdRoot),
      cdScrim = $(".cdrw-scrim", cdRoot),
      cdLines = $("[data-cart-lines]", cdRoot),
      cdCountEl = $("[data-cart-count]", cdRoot),
      cdTotalEl = $("[data-cart-total]", cdRoot),
      cdSubEl = $("[data-cart-sub]", cdRoot),
      cdSumSub = $("[data-sum-sub]", cdRoot),
      cdSumShip = $("[data-sum-ship]", cdRoot),
      cdSumOff = $("[data-sum-disc]", cdRoot),
      cdSumOffR = $("[data-sum-disc-row]", cdRoot),
      cdApplied = $("[data-cart-applied]", cdRoot),
      cdAppCode = $("[data-cart-applied-code]", cdRoot),
      cdDiscForm = $("[data-cart-discount]", cdRoot),
      cdSugWrap = $("[data-cart-suggest-wrap]", cdRoot),
      cdSugRow = $("[data-cart-suggest]", cdRoot),
      cdSubunit = Number(T.moneySubunit) || 100,
      cdCart = null,
      cdSugDone = false,
      /* A-389: the suggestion catalogue, parsed once per page. cdSugDone is reset on
         every cart change so the row can re-filter; this stops that re-running a
         ~312 KB JSON parse each time. */
      cdSugCache = null,
      cdBusy = false,
      cdDiscBusy = false;

    function cdEsc(t) {
      return String(t)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    /* `/cart.js` returns CENTS, unlike `/products.json` which returns decimal strings. fmtKD already
       knows the subunit — the mistake to avoid is dividing twice. */
    /* The shop's money_format template, not a hardcoded suffix — the third of the three money
       implementations, now a thin alias over the shared one (audit P3). */
    function cdMoney(cents) {
      return moneyFromCents(cents);
    }

    /* Six plural forms, chosen by the browser rather than by a hand-rolled rule. Arabic needs
       zero/one/two/few/many/other, and `n === 1` is wrong in five of those six cases. */
    function cdCountText(n) {
      var forms = (T.strings && T.strings.itemsCount) || {};
      var key = "other";
      try {
        key = new Intl.PluralRules(T.locale || "ar").select(n);
      } catch (e) {}
      return String(forms[key] || forms.other || "{n}").replace("{n}", n);
    }

    /* The product page already owns the bottom of the screen. Rather than overlapping its sticky
       add-to-cart, the bar is lifted by that bar's MEASURED height — measured, not assumed, because
       it only displays under 760px and its height depends on how the title wraps. */
    function cdOffsetSticky() {
      var st = $(".stickyatc"),
        h = 0;
      if (st && getComputedStyle(st).display !== "none")
        h = st.getBoundingClientRect().height;
      cdRoot.style.setProperty("--cbar-lift", Math.round(h) + "px");
    }

    function cdShow(on) {
      /* A-254: classes, not hidden flips - the CSS animates both directions, the scrim
         fades, and the page behind stops scrolling while the drawer is up. */
      cdPanel.classList.toggle("open", on);
      cdScrim.classList.toggle("open", on);
      document.documentElement.classList.toggle("cdrw-lock", on);
      /* Focus moves INTO the dialog on open (audit P3). The close side already returned focus to
         the bar; the open side let Tab keep walking the supposedly-inert page behind the scrim.
         The close button is the right landing: first interactive element, and Escape/activate
         both leave the drawer from there. */
      if (on) {
        cdRender();
        cdSuggest();
        var x = $(".cdrw-x", cdPanel);
        if (x) x.focus();
      }
    }

    function cdSetBar(cart) {
      if (!cart) return;
      cdCart = cart;
      var n = cart.item_count;
      if (cdCountEl) cdCountEl.textContent = cdCountText(n);
      /* A-304: in local-price markets the totals are written ONLY by the server-rendered
         section (cdRender) - a KWD write here would flash the wrong currency between the
         change and the fetch. */
      if (!T.mktLocal) {
        if (cdTotalEl) cdTotalEl.textContent = cdMoney(cart.total_price);
        /* `data-cart-sub` is the GRAND total, not the subtotal - it sits on the المجموع row. The
           subtotal has its own element, because with a code applied the two genuinely differ. */
        if (cdSubEl) cdSubEl.textContent = cdMoney(cart.total_price);
      }
      cdSetSummary(cart);
      /* The drawer's meter was rendering blank — markup present, message and percent empty — because
         nothing ever called renderFS for it. renderFS only ran from the cart PAGE's own handlers, and
         the drawer exists on every page. It updates every `.fsbar` in the document by design, so one
         call here serves the drawer and leaves the page's copy correct. */
      /* SUBTOTAL, not total. Shopify's own free-delivery discount triggers on
         greaterThanOrEqualToSubtotal 30.0 — so a meter measured on the post-discount total would tell
         a customer with a code that they still had further to go when Shopify had already granted it.
         The delivery row uses the same basis; the two cannot disagree in the same drawer. */
      renderFS(cart.items_subtotal_price);
      cdBar.hidden = n < 1;
      if (n < 1) cdShow(false);
      cdOffsetSticky();
    }

    /* Subtotal / delivery / discount / total. Everything here comes from `/cart.js`; nothing is
       estimated.

       A-389, MONEY-CRITICAL — READ BEFORE CHANGING THE SUBTOTAL BASIS.
       The subtotal is `original_total_price` (the lines at FULL price), NOT
       `items_subtotal_price`. Shopify's items_subtotal_price is already NET of LINE-level
       discounts, while `total_discount` INCLUDES them — so pairing the two deducted the same
       discount twice. Live example, measured on the store's own 10%-at-quantity-2 promo:
           الإجمالي الفرعي 41.400 · الخصم −4.600 · المجموع 41.400
       and 41.400 − 4.600 = 36.800. The customer read a number LOWER than they were about to
       pay, three centimetres above the pay button. The total was never wrong; the story was.

       The identity that holds for every discount type, line-level or cart-level, is
           original_total_price − total_discount === total_price
       and that is the ledger these three rows now print. Which item earned the discount is
       shown by the struck-through original on the line itself (cart-drawer-lines.liquid),
       matching main-cart.liquid and main-order.liquid.

       Do NOT "simplify" this back to items_subtotal_price. The free-delivery meter below is a
       different question and correctly stays on items_subtotal_price — Shopify's own
       free-shipping rule triggers on greaterThanOrEqualToSubtotal. */
    function cdSetSummary(cart) {
      if (!T.mktLocal && cdSumSub)
        cdSumSub.textContent = cdMoney(cart.original_total_price);

      cdSetShipping(cart);

      /* Hidden entirely at zero rather than showing an empty discount line. */
      var off = Number(cart.total_discount) || 0;
      if (cdSumOffR) cdSumOffR.hidden = off <= 0;
      if (cdSumOff && off > 0) cdSumOff.textContent = "−" + cdMoney(off);

      cdSetApplied(cart);
    }

    /* DELIVERY ROW — A-260, MONEY-CRITICAL, READ BEFORE "IMPROVING" THIS.

       This row previously fetched the real rate from `/cart/shipping_rates.json` and painted it
       as a number. That number was TRUE — and the summary was still WRONG, because the المجموع
       row is `cart.total_price`, which by Shopify's design EXCLUDES shipping (shipping is added
       at checkout). The customer read: subtotal 1.500 · delivery 1.000 · total 1.500 — broken
       arithmetic on its face, and a bigger charge waiting one screen later. The owner's ruling:
       money display must be bulletproof.

       The rule this row now follows: NEVER show a delivery figure the Total cannot contain.
       Two statements are always consistent with cart.total_price and therefore allowed:
         · "مجاني"            — free shipping earned (adds 0, total unaffected)
         · "تُحسب عند الدفع"  — paid shipping exists, quoted and charged at checkout
       A concrete paid figure is neither, so it does not belong here. If the theme ever wants to
       show the true payable total, the ONLY correct form is total = cart.total_price + rate on
       the SAME row, never a side-by-side that disagrees. */
    function cdSetShipping(cart) {
      if (!cdSumShip) return;
      var S = T.strings || {};
      var th = Number(T.freeShippingThreshold) || 0;
      /* The threshold is measured on the SUBTOTAL, matching both the owner's rule and Shopify's own
         automatic discount (greaterThanOrEqualToSubtotal 30.0) — not on the post-discount total,
         which would quietly raise the bar for anyone using a code. */
      var basis = Number(cart.items_subtotal_price) || 0;

      if (
        T.mktMeter !== false &&
        th > 0 &&
        T.freeDelivery !== false &&
        basis >= th
      ) {
        cdSumShip.textContent = S.deliveryFree || "";
        cdSumShip.classList.add("is-free");
        return;
      }
      cdSumShip.classList.remove("is-free");
      cdSumShip.textContent = S.deliveryAtCheckout || "";
    }

    /* The applied code, so the cart stops pretending it does not know about a discount it is already
       giving. `discount_codes` lists what is attached; `applicable:false` means Shopify is holding a
       code it will not honour for this cart, and showing that as applied would be a lie. */
    function cdSetApplied(cart) {
      if (!cdApplied) return;
      var codes = (cart.discount_codes || []).filter(function (d) {
        return d && d.applicable;
      });
      var has = codes.length > 0;
      cdApplied.hidden = !has;
      if (has && cdAppCode)
        cdAppCode.textContent = codes
          .map(function (d) {
            return d.code;
          })
          .join(", ");
      /* Collapse the input while a code is live, but keep it in the DOM so the swap button can bring
         it back. Re-opened forms stay open until the next cart update. */
      if (cdDiscForm) cdDiscForm.hidden = has;
    }

    /* A-304: the lines are SERVER-rendered now (sections/cart-drawer-lines.liquid) and
       fetched through the Section Rendering API. The old client-side builder could only
       print the KWD charge, because /cart.js carries no metafields - so a Saudi customer
       saw the committed local price on every card and KWD in the drawer. The section
       reads the same committed metafield as the cards; the totals ride in the same
       response as the lines, so no two cart surfaces can describe two different carts.
       cart-gift.js's [data-gift-line] contract is honoured by the section. Stale
       responses are dropped by sequence. */
    var cdRenderSeq = 0;
    /* A-319: the committed products-value rides to CHECKOUT as a cart attribute -
       Checkout Blocks prints {{ checkout.attributes._t3b_local_total }} there, and
       this is the only honest pipe into that page. Stamped in the background after
       every section apply, only when the value actually changed; cleared (empty
       string) whenever the arbiter refuses local display, so checkout can never
       show a number the cart would not. */
    var cdAttrLast = null;
    var cdAttrPending = null;
    function cdStampAttr(val) {
      if (val === cdAttrLast) return;
      cdAttrLast = val;
      /* Dash-named, NOT underscored: Checkout Blocks renders its text as MARKDOWN,
         and markdown consumes underscores as italics before Liquid runs - measured
         live with the owner (the key printed as <em>t3b</em>local_total). The old
         underscored key is emptied alongside so stale carts carry one truth. */
      cdAttrPending = fetch(ROOT + "/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: { "t3b-local-total": val, _t3b_local_total: "" },
        }),
      })
        .catch(function () {
          cdAttrLast = null; /* retry on the next change */
        })
        .then(function () {
          cdAttrPending = null;
        });
    }
    /* The checkout button is a plain form POST; if an attribute stamp is still in
       flight, hold the submit for it (800 ms cap) so checkout never renders a
       total from the PREVIOUS cart (audit T6). form.submit() drops the button's
       name, and name="checkout" is what routes a /cart POST to checkout - re-add
       it as a hidden field before submitting programmatically. */
    /* AUDIT B-15: the pre-checkout wait now covers BOTH what it always
       covered (the attribute stamp) and a cart mutation still in flight
       (cdBusy) - checkout could previously be entered from the pre-tap cart.
       Shared by the form path and the KW <a> path below. */
    function cdQuiet() {
      var attr = cdAttrPending || Promise.resolve();
      var busy = new Promise(function (r) {
        (function chk() {
          if (!cdBusy) return r();
          setTimeout(chk, 100);
        })();
      });
      return Promise.race([
        Promise.all([attr, busy]),
        new Promise(function (r) {
          setTimeout(r, 800);
        }),
      ]);
    }
    document.addEventListener(
      "submit",
      function (e) {
        var f = e.target;
        if (!f.classList || !f.classList.contains("cdrw-co")) return;
        if (!cdAttrPending && !cdBusy) return;
        e.preventDefault();
        var go = function () {
          if (!f.querySelector('input[name="checkout"]')) {
            var h = document.createElement("input");
            h.type = "hidden";
            h.name = "checkout";
            h.value = "";
            f.appendChild(h);
          }
          f.submit();
        };
        cdQuiet().then(go, go);
      },
      true,
    );
    /* A-389: the AUDIT B-15 anchor guard that used to sit here has been REMOVED.
       It matched `a.cdrw-checkout` — the drawer's checkout link back when the KW market
       routed through the pre-checkout address page. Kuwait-only step 1 retired that
       page, and layout/theme.liquid:515-517 now renders a real
       `<form action="/cart" method="post"><button name="checkout">`. So the selector
       could not match anything, while its comment asserted the opposite and the layout
       file asserted the opposite of THAT — two files disagreeing about which checkout
       path exists. The form's submit is already covered by the submit handler above,
       which is where the cdQuiet() drain belongs. */
    /* A-369: responses apply in REQUEST-START order, not arrival order. An
       add from the PDP and a drawer tap can overlap; without this, whichever
       response arrived last painted, even if its request was older. */
    var cdLastApplied = 0;
    function cdApplySection(html, reqT) {
      if (reqT && reqT < cdLastApplied)
        return; /* an older request's answer - a newer truth already painted */
      if (reqT) cdLastApplied = reqT;
      /* Applying a mutation response is the newest truth - invalidate any fetch in flight. */
      ++cdRenderSeq;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var src = doc.querySelector("[data-cd-lines-src]");
      if (src) cdLines.innerHTML = src.innerHTML;
      var pairs = [
        ["[data-cd-tsub]", cdSumSub],
        ["[data-cd-ttot]", cdSubEl],
        ["[data-cd-tpill]", cdTotalEl],
        ["[data-cd-tsbar]", $("[data-sbar-total]")],
      ];
      pairs.forEach(function (p) {
        var t = doc.querySelector("template" + p[0]);
        if (t && p[1]) p[1].innerHTML = t.innerHTML;
      });
      var ta = doc.querySelector("template[data-cd-tattr]");
      if (ta) cdStampAttr(ta.innerHTML.trim());
      /* A-359: the swap paints SERVER truth - older than any want still queued
         behind cdBusy. Re-paint pending wants so a rapid tap series never flashes
         backwards; the queued send replaces this with real truth moments later. */
      for (var wk in cdWant) {
        if (Object.prototype.hasOwnProperty.call(cdWant, wk))
          cdPaintWant(wk, cdWant[wk]);
      }
    }
    /* Fallback ONLY - reconciliation paths with no piggybacked section (bfcache return,
       discount apply, safety refresh on open). Never sits between a tap and its feedback. */
    function cdRender() {
      var seq = ++cdRenderSeq;
      var t0 = performance.now(); /* A-369: request-start stamp */
      fetch(ROOT + "/?section_id=cart-drawer-lines")
        .then(function (r) {
          if (!r.ok) throw new Error("section");
          return r.text();
        })
        .then(function (html) {
          if (seq !== cdRenderSeq) return;
          cdRenderSeq--; /* let the apply below win the seq it checked */
          cdApplySection(html, t0);
        })
        .catch(function () {});
    }

    /* The stock-limit strip. `/cart/change.js` answers 422 with {message, description} when a
       quantity exceeds stock — routine for single-lot honey — and the old code piped that ERROR
       OBJECT straight into cdSetBar, so one tap too many on "+" rendered the whole cart as
       "0.000 KD" with no explanation. Shopify's description arrives already localized; the locale
       string is only the fallback for a body that would not parse. */
    var cdErrEl = $("[data-cart-error]", cdRoot),
      cdErrTimer = null;
    function cdShowErr(msg) {
      if (!cdErrEl) return;
      cdErrEl.textContent = msg || (T.strings && T.strings.cartError) || "";
      cdErrEl.hidden = !cdErrEl.textContent;
      clearTimeout(cdErrTimer);
      cdErrTimer = setTimeout(function () {
        cdErrEl.hidden = true;
      }, 5000);
    }

    /* Desired quantity per line, surviving the request in flight. `if (cdBusy) return;` DROPPED
       taps: three quick "+" was +1, because the second and third arrived mid-flight and were
       thrown away (audit P3). Now every tap records what the customer wants; the in-flight
       completion sends again if the want moved. Latest wins, requests never overlap, and the
       stepper reads from the want so each tap builds on the last tap, not on the stale cart. */
    var cdWant = {};
    /* A-359: paint the tap NOW. The server round trip is ~0.8s (measured: change.js
       with its piggybacked section render = 769ms) and nothing theme-side can shrink
       it - but the customer's number can move in the same frame as the tap. The
       quantity shown is the WANT (already the tap-stacking source of truth); money
       stays server-rendered (Rule 0.5) and just dims until the section swap lands,
       which replaces this painted HTML with the real cart wholesale. */
    function cdPaintWant(key, qty) {
      var line = cdLines.querySelector('.cdrw-line[data-key="' + key + '"]');
      if (!line) return;
      if (qty <= 0) {
        line.classList.add("cd-removing");
      } else {
        /* AUDIT B-14: a line brought back from a pending remove must lose
           the removing state, or it stays untappable and half-invisible. */
        line.classList.remove("cd-removing");
        var s = line.querySelector(".cdrw-qty span");
        if (s) s.textContent = qty;
        line.classList.add("cd-busy");
      }
    }
    /* A-389: undo the optimistic paint on ONE line without depending on a re-render.
       When the connection is down the mutation fails AND cdRender() fails, and a line
       tapped for removal was left wearing `.cd-removing` - opacity .35 with
       pointer-events:none. Visually removed, impossible to tap again, and still
       correctly counted in the total. Only closing and reopening the drawer repaired
       it, and nothing on screen said so. */
    function cdClearPaint(key) {
      var line = cdLines.querySelector('.cdrw-line[data-key="' + key + '"]');
      if (line) line.classList.remove("cd-removing", "cd-busy");
    }
    function cdChange(key, qty) {
      cdWant[key] = qty;
      cdPaintWant(key, qty);
      if (cdBusy) return; /* the completion below flushes the new want */
      cdSend(key);
    }
    function cdSend(key) {
      var qty = cdWant[key];
      cdBusy = true;
      var t0 = performance.now(); /* A-369: request-start stamp */
      /* AUDIT B-14: a request that never settles used to wedge cdBusy=true
         forever - every later tap painted but never sent. 10s abort forces
         the chain to its catch/finally. */
      var cdAbort =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      var cdAbortTimer = cdAbort
        ? setTimeout(function () {
            cdAbort.abort();
          }, 10000)
        : null;
      fetch(ROOT + "/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        signal: cdAbort ? cdAbort.signal : undefined,
        body: JSON.stringify({
          id: key,
          quantity: qty,
          sections: "cart-drawer-lines",
        }),
      })
        .then(function (r) {
          /* The check its sibling pushCartChange always had. Without it the 422 body flows into
             the render path as if it were a cart. */
          if (!r.ok) {
            return r.json().then(
              function (err) {
                cdShowErr(err && (err.description || err.message));
                throw new Error("cart change rejected");
              },
              function () {
                cdShowErr("");
                throw new Error("cart change rejected");
              },
            );
          }
          return r.json();
        })
        .then(function (cart) {
          if (cdErrEl) {
            cdErrEl.hidden = true;
            clearTimeout(cdErrTimer);
          }
          cdSetBar(cart);
          /* change.js rendered the section in THIS response - apply, no second trip. */
          var sh = cart.sections && cart.sections["cart-drawer-lines"];
          if (sh) cdApplySection(sh, t0);
          else cdRender();
          /* prev BEFORE setBadge — setBadge is what advances lastCartCount. */
          var prev = lastCartCount;
          setBadge(cart.item_count);
          renderTopFS(cart.items_subtotal_price);
          announceCart(cart, prev);
          /* cart-gift.js re-evaluates on `t3b:cart:updated` (it also hears `t3b:cart` now). This
             is the drawer's only dispatcher of it since the cart page's swapCart was deleted —
             without it a customer could remove the gift, or drop below the qualifying amount, and
             nothing would notice. */
          document.dispatchEvent(
            new CustomEvent("t3b:cart:updated", { detail: cart }),
          );
        })
        .catch(function () {
          /* A-359: a refused mutation (stock-cap 422, network) must also UNDO the
             optimistic paint. AUDIT B-13: a REJECTED fetch (offline) reached
             here without any error shown - the optimistic lie stood silently.
             Show the generic strip too; the 422 path above still shows
             Shopify's specific message. */
          cdShowErr("");
          /* A-389: clear this line's optimistic paint BEFORE attempting the re-render,
             so an offline customer gets a tappable line back even when cdRender() fails
             too. Only when the want is still OURS - if the customer tapped again while
             this was in flight, that newer want owns the paint and will re-send. */
          if (cdWant[key] === qty) cdClearPaint(key);
          cdRender();
        })
        .then(function () {
          if (cdAbortTimer) clearTimeout(cdAbortTimer);
          cdBusy = false;
          /* Clear this line if its want didn't move; if it did, it stays pending and the sweep
             below re-sends it. Identical want is cleared so a stock-capped quantity cannot loop.
             THEN flush the next pending line (A-256): a tap on a SECOND line while this one was
             in flight used to sit in cdWant forever, because this completion only ever looked at
             its own key. One send at a time — cdBusy keeps them serialized. */
          if (cdWant[key] === qty) delete cdWant[key];
          for (var nk in cdWant) {
            if (Object.prototype.hasOwnProperty.call(cdWant, nk)) {
              cdSend(nk);
              break;
            }
          }
        });
    }

    /* Suggestions. The owner's chosen collection first, Shopify's related products only as a
       fallback. Measured on this store: `intent=complementary` returns NOTHING, because Search &
       Discovery has none configured — so it is not used at all rather than silently rendering an
       empty row. Anything already in the cart is filtered out, and if nothing survives, the whole
       block stays hidden rather than showing a heading over emptiness. */
    function cdSuggest() {
      if (cdSugDone || !cdCart || !cdCart.items.length) return;
      cdSugDone = true;
      var handle = cdRoot.getAttribute("data-suggest-collection");
      var inCart = {};
      cdCart.items.forEach(function (i) {
        inCart[i.product_id] = true;
      });
      /* THE WHOLE CATALOGUE by default, at the owner's instruction — "the whole products not only
         spoons". With no collection set this used to ask `/recommendations` for related products,
         which returns whatever Shopify thinks is similar and cannot be sorted by price across the
         store. `/products.json` returns every product published to the online store (250 max, and
         the catalogue is 64), so the six cheapest are genuinely the six cheapest.

         Setting a collection still scopes it, for when he wants to steer the row deliberately.
         Both endpoints return DECIMAL STRING prices, which is why the normalisation below no longer
         forks on the source. */
      var url = handle
        ? ROOT +
          "/collections/" +
          encodeURIComponent(handle) +
          "/products.json?limit=250"
        : ROOT + "/products.json?limit=250";

      /* A-389: PARSE THE CATALOGUE ONCE PER PAGE.
         `cdSugDone` is reset on every t3b:cart (correctly - a product just added has to
         drop out of the row), which meant every single add re-ran this fetch and
         re-parsed ~312 KB of JSON while the drawer was open. Not a download: the server
         answers 304 and the browser serves it from cache. It IS a real parse + sort on
         the main thread per tap, right in the middle of the add animation. The filtering
         is the only part that depends on the cart, so cache the payload and redo just
         that. Availability cannot go stale here - every variant on this store is
         `tracked: false`. */
      var cdSugGot = cdSugCache
        ? Promise.resolve(cdSugCache)
        : fetch(url)
            .then(function (r) {
              if (!r.ok) throw new Error("suggest fetch " + r.status);
              return r.json();
            })
            .then(function (j) {
              cdSugCache = j;
              return j;
            });

      cdSugGot
        .then(function (j) {
          /* Prices are DECIMAL STRINGS from both endpoints now, normalised to subunits once — the
           moment prices are sorted rather than merely printed, "6.750" against 675 stops being a
           formatting nit and becomes a nonsense order. */
          var list = (j.products || [])
            .filter(function (p) {
              return !inCart[p.id];
            })
            .map(function (p) {
              /* CHEAPEST VARIANT, not the first — sorting by whichever variant an endpoint
               happens to list first would rank a product by an arbitrary size rather than by
               what it actually costs to try.
               A-389 CORRECTION: this note used to claim "many products have several sizes".
               That is FALSE against the live catalogue — all 67 products are single-variant
               and sizes are modelled as separate products (verified 2026-08-20). The loop is
               kept because it is correct either way and costs nothing, but nobody should read
               the old claim and design around a multi-variant catalogue that does not exist. */
              var v = null,
                cents = Infinity;
              (p.variants || []).forEach(function (x) {
                if (x.available === false) return;
                var c = Math.round(parseFloat(x.price) * cdSubunit);
                if (isFinite(c) && c < cents) {
                  cents = c;
                  v = x;
                }
              });
              return { p: p, v: v || {}, cents: cents };
            })
            /* Only what can actually be added — a quick-add button on a sold-out variant is a button
             that fails when pressed. Products whose every variant is unavailable leave `v` null and
             `cents` at Infinity, and drop out here. */
            .filter(function (o) {
              return o.v.id && o.cents !== Infinity;
            })
            /* CHEAPEST FIRST, at the owner's instruction, and the slice happens AFTER the sort so the
             ones kept are the cheapest rather than the ones the endpoint happened to return first.
             Fifteen, raised from six — the row scrolls sideways, so a longer list costs height
             nothing and only the first few are visible until the customer flicks through them. */
            .sort(function (a, b) {
              return a.cents - b.cents;
            })
            .slice(0, 15);

          if (!list.length) return;
          /* A-389: keep the customer's place. Rewriting innerHTML resets scrollLeft, so
             adding a jar while browsing this row snapped it back to the start mid-flick. */
          var cdSugScroll = cdSugRow.scrollLeft;
          cdSugRow.innerHTML = list
            .map(function (o) {
              var p = o.p,
                im = (p.images || [])[0];
              var src = im ? im.src || im : "";
              /* A-304: /products.json carries no metafields, so in local-price markets a KWD
             label here would be the one wrong-currency number in the drawer. No price on
             the tile beats a price the customer cannot reconcile; the line that appears
             after adding carries the correct local price from the section render. */
              var label =
                T.mktLocal || o.cents === Infinity ? "" : cdMoney(o.cents);
              /* The card is an anchor and a button cannot be nested inside one, so the two are siblings
             in a positioned wrapper. The button carries `data-quick-add`, which the document-level
             delegate already handles — no second add path, and it inherits the flying bee, the badge
             update and the `t3b:cart` event for free. */
              return (
                '<div class="cdrw-sug-i">' +
                '<a class="cdrw-sug-l" href="' +
                ROOT +
                "/products/" +
                cdEsc(p.handle) +
                '">' +
                (src
                  ? '<img src="' +
                    cdEsc(
                      String(src).replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2"),
                    ) +
                    '" alt="" loading="lazy">'
                  : '<span class="cdrw-noimg"></span>') +
                '<span class="cdrw-sug-t">' +
                cdEsc(p.title) +
                "</span>" +
                '<span class="cdrw-sug-p">' +
                cdEsc(label) +
                "</span></a>" +
                '<button type="button" class="cdrw-sug-add" data-quick-add="' +
                cdEsc(o.v.id) +
                '"' +
                ' aria-label="' +
                cdEsc((T.strings && T.strings.addToCart) || "+") +
                '"' +
                ' title="' +
                cdEsc((T.strings && T.strings.addToCart) || "+") +
                '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true">' +
                '<path d="M12 5v14M5 12h14"/></svg></button></div>'
              );
            })
            .join("");
          cdSugWrap.hidden = false;
          /* A-389: restore the flick position the innerHTML rewrite just discarded. */
          if (cdSugScroll) cdSugRow.scrollLeft = cdSugScroll;
          /* A-304 (owner: "the cards in أكمل طلبك has no prices"): in committed-currency
           markets each tile resolves its price from the mkt-tile-price section on its own
           product URL - the same metafield source as the cards and the drawer lines, so
           the row can never show a number the rest of the store disagrees with. The
           requests run in parallel after the row is already visible, page-cached per
           product+country; nothing the customer taps waits on them. */
          if (T.mktLocal) {
            var tiles = cdSugRow.children;
            list.forEach(function (o, i) {
              var slot = tiles[i] && tiles[i].querySelector(".cdrw-sug-p");
              if (!slot) return;
              fetch(
                ROOT +
                  "/products/" +
                  encodeURIComponent(o.p.handle) +
                  "?section_id=mkt-tile-price",
              )
                .then(function (r) {
                  if (!r.ok) throw new Error("tile");
                  return r.text();
                })
                .then(function (h) {
                  var d = new DOMParser().parseFromString(h, "text/html");
                  var n = d.querySelector("[data-tile-price]");
                  if (n) slot.innerHTML = n.innerHTML;
                })
                .catch(function () {});
            });
          }
        })
        .catch(function () {});
    }

    cdBar.addEventListener("click", function (e) {
      e.preventDefault();
      cdShow(true);
    });
    /* A-309: the top meter invites - tapping it opens the cart it is measuring. */
    var tfsEl = $("[data-top-fs]");
    if (tfsEl)
      tfsEl.addEventListener("click", function () {
        if (cdBar.hidden) {
          showToast((T.strings && T.strings.cartEmpty) || "");
          return;
        }
        cdShow(true);
      });
    $$("[data-cart-close]", cdRoot).forEach(function (b) {
      b.addEventListener("click", function () {
        cdShow(false);
        cdBar.focus();
      });
    });

    /* PULL-DOWN-TO-CLOSE (owner: "if I reached the top of the cart, and made another swipe, the
       cart goes down"). Deliberately gated on the gesture STARTING at scrollTop 0 — his exact
       flow: scroll to the top, then one more pull dismisses. A drag that begins mid-list is
       ordinary scrolling and is never touched. Gestures starting in the note or discount fields
       are excluded; touchmove is non-passive only so the panel can own the drag once engaged
       (preventDefault stops iOS rubber-banding under the pull). Short pulls spring back via the
       panel's own transform transition; past the threshold the panel follows through, slides out
       and closes. */
    var pullY0 = null,
      pullAtTop = false,
      pulling = false,
      pullDy = 0;
    cdPanel.addEventListener(
      "touchstart",
      function (e) {
        if (!cdPanel.classList.contains("open") || e.touches.length !== 1) {
          pullY0 = null;
          return;
        }
        if (e.target.closest && e.target.closest("input,textarea,select")) {
          pullY0 = null;
          return;
        }
        pullY0 = e.touches[0].clientY;
        pullAtTop = cdPanel.scrollTop <= 0;
        pulling = false;
        pullDy = 0;
      },
      { passive: true },
    );
    cdPanel.addEventListener(
      "touchmove",
      function (e) {
        if (pullY0 === null || !pullAtTop) return;
        var dy = e.touches[0].clientY - pullY0;
        if (!pulling) {
          if (dy < 8)
            return; /* upward or trivial: normal scrolling's business */
          pulling = true;
          cdPanel.classList.add("cdrw-pulling");
        }
        pullDy = Math.max(0, dy);
        e.preventDefault();
        cdPanel.style.transform = "translateY(" + pullDy + "px)";
      },
      { passive: false },
    );
    function cdPullEnd() {
      if (pullY0 === null) return;
      var was = pulling,
        dy = pullDy;
      pullY0 = null;
      pulling = false;
      pullDy = 0;
      cdPanel.classList.remove("cdrw-pulling");
      if (!was) return;
      if (dy > 110) {
        cdPanel.style.transform =
          "translateY(108%)"; /* follow through, then hide */
        var done = function () {
          cdPanel.style.transform = "";
          cdShow(false);
          cdBar.focus();
        };
        if (RM) done();
        else setTimeout(done, 240);
      } else {
        cdPanel.style.transform = ""; /* the base transition springs it home */
      }
    }
    cdPanel.addEventListener("touchend", cdPullEnd, { passive: true });
    cdPanel.addEventListener("touchcancel", cdPullEnd, { passive: true });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && cdPanel.classList.contains("open")) {
        cdShow(false);
        cdBar.focus();
      }
    });

    cdLines.addEventListener("click", function (e) {
      var line = e.target.closest(".cdrw-line");
      if (!line) return;
      var key = line.getAttribute("data-key");
      if (!key) return;
      /* A-389: DO NOT GATE THIS HANDLER ON `cdCart`.
         Identity and quantity both already live in the DOM - the key on the line, the
         number in `.cdrw-qty span` that cdPaintWant itself writes to. This used to look
         the line up in the cart object fetched at boot and `return` when it was absent,
         which made +, − and the remove X silently dead whenever that fetch failed. It
         fails more easily than it looks: there is no r.ok check on it, so a 4xx HTML
         body throws inside r.json() straight into an empty catch and leaves cdCart null
         forever. The drawer still LOOKED correct throughout, because the lines are
         server-rendered - so the customer taps remove three times, concludes the shop is
         broken, and leaves. Since the cart page was retired this drawer is the only cart
         surface the store has. There was also a window on EVERY page load, between the
         buttons becoming clickable and that fetch resolving, where taps died the same way. */
      if (e.target.closest("[data-cd-remove]")) {
        cdChange(key, 0);
        return;
      }
      var step = e.target.closest("[data-cd-step]");
      if (!step) return;
      /* Build on the WANT when one is pending: mid-flight the rendered quantity is still
         the old cart, and three taps computed old+1 three times. */
      var base;
      if (key in cdWant) {
        base = cdWant[key];
      } else {
        var qEl = line.querySelector(".cdrw-qty span");
        base = qEl ? parseInt(qEl.textContent, 10) : NaN;
        if (!isFinite(base)) {
          /* Last resort only - the cart object if we happen to have it, else 0, which
             makes "+" read as 1 rather than doing nothing at all. */
          var item =
            cdCart &&
            cdCart.items.filter(function (i) {
              return i.key === key;
            })[0];
          base = item ? item.quantity : 0;
        }
      }
      cdChange(
        key,
        Math.max(0, base + Number(step.getAttribute("data-cd-step"))),
      );
    });

    /* DISCOUNT CODE, APPLIED WITHOUT LEAVING THE PAGE.
       `/cart/update.js` genuinely has no discount field on a non-Plus store, and the earlier note
       here concluded from that a full navigation was unavoidable. THAT WAS WRONG. `/discount/<CODE>`
       sets the cookie through a background `fetch` just as well as through a navigation — proven on
       2026-08-05 by fetching a code that cannot exist and watching it appear in `/cart.js` as
       `applicable:false` with the page never moving. The reload was never required; it was inferred.

       ⚠ CODES ACCUMULATE. A failed attempt stays in `discount_codes` forever, so "did it work" can
       only be answered by finding THE ENTERED CODE with `applicable:true`. A 200 response means
       Shopify received the code, not that it honoured it. */
    if (cdDiscForm) {
      var cdDiscErr = $("[data-cart-discount-error]", cdRoot);
      var cdDiscBtn = cdDiscForm.querySelector("button");

      function cdDiscFallback(code) {
        window.location.href =
          ROOT +
          "/discount/" +
          encodeURIComponent(code) +
          "?redirect=" +
          encodeURIComponent(location.pathname + location.search);
      }

      cdDiscForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = $("[data-cart-discount-input]", cdDiscForm);
        var code = (input.value || "").trim();
        if (!code || cdDiscBusy) return;
        cdDiscBusy = true;
        if (cdDiscBtn) cdDiscBtn.disabled = true;
        if (cdDiscErr) cdDiscErr.hidden = true;

        fetch(ROOT + "/discount/" + encodeURIComponent(code), {
          credentials: "same-origin",
        })
          .then(function () {
            return fetch(ROOT + "/cart.js");
          })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var hit = (cart.discount_codes || []).filter(function (d) {
              return d.code && d.code.toUpperCase() === code.toUpperCase();
            })[0];
            if (hit && hit.applicable) {
              input.value = "";
              /* cdSetBar redraws the summary, the applied chip, the meter and the bar in one pass,
                 so the whole drawer settles without a repaint of the page. */
              cdSetBar(cart);
              if (cdPanel.classList.contains("open")) cdRender();
            } else if (cdDiscErr) {
              cdDiscErr.hidden = false;
            }
          })
          /* Only a genuine network/CORS failure lands here — a rejected CODE resolves normally and is
             handled above. Falling back to the navigation means this can get better, never worse. */
          .catch(function () {
            cdDiscFallback(code);
          })
          .then(function () {
            cdDiscBusy = false;
            if (cdDiscBtn) cdDiscBtn.disabled = false;
          });
      });
    }

    /* "Use another code" — reopens the collapsed field. There is no API to REMOVE a discount code
       from a cart on a non-Plus store, so the only real action available is replacing it, and this
       button offers exactly that rather than a remove control that could not work. */
    var cdSwap = $("[data-cart-discount-swap]", cdRoot);
    if (cdSwap && cdDiscForm) {
      cdSwap.addEventListener("click", function () {
        cdDiscForm.hidden = false;
        var f = $("[data-cart-discount-input]", cdDiscForm);
        if (f) {
          f.value = "";
          f.focus();
        }
      });
    }

    /* The header cart icon — and the sidebar's cart row ([data-open-cart], A-143) — open the
       drawer instead of navigating. Both stay real links to /cart, so without JavaScript they
       still reach the cart — the drawer is the enhancement, not the only route. */
    $$(".cartb, [data-open-cart]").forEach(function (cdIcon) {
      cdIcon.addEventListener("click", function (e) {
        e.preventDefault();
        /* EMPTY CART: say so, in place. "Let the link do its normal job" was written when /cart
           was a page; now that route bounces straight back, so the click navigated a full round
           trip and showed nothing at all — a dead click (audit P2-10). */
        if (cdBar.hidden) {
          showToast((T.strings && T.strings.cartEmpty) || "");
          return;
        }
        cdShow(true);
      });
    });

    /* Raised by ajaxAdd rather than called from it, so the two do not depend on declaration order. */
    document.addEventListener("t3b:cart", function (e) {
      cdSugDone = false;
      cdSetBar(e.detail);
      /* Header badge and top meter too. ajaxAdd updates them itself, so for its dispatch this is a
         harmless double-set — but cart-gift.js now raises this same event after adding or removing
         the gift, and without these two calls the header badge kept the OLD count while the drawer
         bar showed the new one, on the same screen. Any future dispatcher gets the full repaint. */
      if (e.detail) {
        var prev = lastCartCount;
        setBadge(e.detail.item_count);
        renderTopFS(e.detail.items_subtotal_price);
        /* The drawer path's screen-reader announcement — the only one left now that swapCart is
           gone. ajaxAdd, suggestions, and cart-gift all funnel through this event. */
        announceCart(e.detail, prev);
      }
      /* A-304: the add response usually carries the rendered section - applying it is a pure
         DOM write, no network. Only dispatchers without one (cart-gift.js, bfcache sync) cost
         a fallback fetch, and for those there is no tap waiting on the result. */
      var sh =
        e.detail &&
        e.detail.__sections &&
        e.detail.__sections["cart-drawer-lines"];
      if (sh) {
        cdApplySection(sh, e.detail.__reqT || performance.now());
      } else if (T.mktLocal || cdPanel.classList.contains("open")) {
        cdRender();
      }
      if (cdPanel.classList.contains("open")) cdSuggest();
    });
    window.addEventListener("resize", cdOffsetSticky);

    /* The payment marks under the checkout button are the FOOTER's row, copied. The icons are footer
       section blocks and a section's blocks cannot be read from the layout, so re-declaring them as
       theme settings would have meant re-uploading every image and maintaining two copies of one
       fact. Cloning keeps a single source: what the owner switches on in the footer shows here.

       Links are stripped. In the footer a mark may link out; three centimetres above the checkout
       button, a link that navigates away is a hole in the funnel — and the customer did not open a
       cart to read about Tamara. Alt text is preserved, so the row still reads correctly aloud. */
    function cdPaintPayIcons() {
      var host = $("[data-cart-pay]", cdRoot);
      var src = $(".ficons-list");
      if (!host || !src) return;
      /* The owner picks which marks belong here — there are 13 icon slots and the row holds seven.
         `[data-cart-icon]` is the tick he sets in Footer → the icon → "Also show in the cart drawer".

         FALLBACK TO THE FIRST SEVEN when he has ticked none. Without it this row would empty itself
         the moment the setting shipped, since no existing block carries the new flag — a silent
         regression on a live storefront caused by adding a feature. */
      var picked = $$(".ficons-i[data-cart-icon]", src);
      var items = (picked.length ? picked : $$(".ficons-i", src)).slice(0, 7);
      if (!items.length) return;
      host.innerHTML = "";
      items.forEach(function (li) {
        var img = $("img", li);
        if (!img) return;
        var el = document.createElement("li");
        el.className = "cdrw-pay-i";
        var c = img.cloneNode(true);
        c.removeAttribute(
          "loading",
        ); /* it is inside a closed drawer; lazy would defer it forever */
        c.removeAttribute("width");
        c.removeAttribute("height");
        el.appendChild(c);
        host.appendChild(el);
      });
      /* Column count follows the ACTUAL number picked. Hard-coding seven would leave three empty
         columns when he ticks four, and the marks would sit bunched to one side. */
      host.style.setProperty("--n", Math.min(host.children.length, 7) || 1);
      /* The WRAPPER is what hides, so the "pay securely" line never sits above an empty space. */
      var wrap = $("[data-cart-pay-wrap]", cdRoot);
      if (wrap) wrap.hidden = !host.children.length;
    }
    cdPaintPayIcons();

    /* Someone reached /cart and was bounced back here. The cart page no longer exists, so the drawer
       has to be what they actually asked for — otherwise the redirect just looks like a dead link.
       The flag is cleared immediately: it describes one navigation, not a preference. */
    function cdCameFromCartUrl() {
      try {
        if (sessionStorage.getItem("t3b:openCart") !== "1") return false;
        sessionStorage.removeItem("t3b:openCart");
        return true;
      } catch (e) {
        return false;
      }
    }

    /* First paint already shows correct numbers from Liquid; this only fetches the line items, and
       only when there is a cart to fetch. */
    if (Number(T.cartCount) > 0) {
      fetch(ROOT + "/cart.js")
        .then(function (r) {
          /* A-389: the r.ok check this fetch never had. Without it a 4xx/5xx HTML body
             throws inside r.json() into the empty catch below, leaving cdCart null and
             the failure completely invisible. The drawer controls no longer depend on
             cdCart (see the cdLines click handler), so this is now a degraded state
             rather than a dead one - but it should still be a real rejection, not a
             parse error pretending to be one. */
          if (!r.ok) throw new Error("cart fetch " + r.status);
          return r.json();
        })
        .then(function (cart) {
          cdSetBar(cart);
          /* A-319: reconcile the checkout attribute on load - a country switch reloads
           the page with a new market, and the stamped value must follow. Seeded from
           the cart's stored value so an unchanged cart costs zero extra requests. */
          cdAttrLast =
            (cart.attributes && cart.attributes["t3b-local-total"]) || "";
          var ta0 = document.querySelector(
            "[data-cart-lines] template[data-cd-tattr]",
          );
          if (ta0) cdStampAttr(ta0.innerHTML.trim());
          if (cdCameFromCartUrl()) cdShow(true);
        })
        .catch(function () {});
    } else {
      cdOffsetSticky();
      /* An empty cart has nothing to open — clear the flag so it cannot fire on a later page. */
      cdCameFromCartUrl();
    }
  }
})();
/* ڤي 12 — the open-the-hood engine (A-197). Self-contained module: tease → dismiss poster
   → play HoodOpen once and freeze open → camera dive → orbit enabled → pins/chips open the
   sheet → fly-to-jar reveals the checkout bar. Chips work even if the model never loads. */
(function () {
  "use strict";
  document.querySelectorAll("[data-mnv-engine]").forEach(function (root) {
    var mv = root.querySelector("model-viewer");
    var dataEl = root.querySelector("[data-mnv-data]");
    var cfg;
    try {
      cfg = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var tease = root.querySelector("[data-mnv-tease]");
    var sheet = root.querySelector("[data-mnv-sheet]");
    var sTitle = root.querySelector("[data-mnv-sheet-title]");
    var sBody = root.querySelector("[data-mnv-sheet-body]");
    var buy = root.querySelector("[data-mnv-buy]");
    var opened = false;

    var stage = root.querySelector(".mnv-eng-stage");
    var shut = root.querySelector("[data-mnv-shut]");
    function enterFull() {
      if (stage) stage.classList.add("is-full");
      document.documentElement.classList.add("mnv-lock");
      if (shut) shut.hidden = false;
      if (mv && opened) mv.setAttribute("camera-controls", "");
    }
    function exitFull() {
      if (stage) stage.classList.remove("is-full");
      document.documentElement.classList.remove("mnv-lock");
      if (shut) shut.hidden = true;
      hideSheet();
      /* inline viewer must never trap the scrolling finger */
      if (mv) mv.removeAttribute("camera-controls");
    }
    function openHood() {
      if (!mv) return;
      enterFull();
      if (opened) return;
      opened = true;
      root.classList.add("is-opening");
      if (tease) tease.hidden = true;
      var started = false;
      function start() {
        if (started) return;
        started = true;
        try {
          mv.play({ repetitions: 1 });
        } catch (e) {
          try {
            mv.play();
          } catch (e2) {}
        }
        mv.addEventListener(
          "finished",
          function () {
            try {
              mv.currentTime = Math.max(0, mv.duration - 0.03);
              mv.pause();
            } catch (e) {}
          },
          { once: true },
        );
        setTimeout(function () {
          mv.setAttribute("camera-orbit", cfg.openOrbit);
          mv.setAttribute("camera-target", cfg.openTarget);
          mv.setAttribute("camera-controls", "");
          root.classList.add("is-open");
        }, 450);
      }
      if (mv.loaded) {
        start();
      } else {
        mv.addEventListener("load", start, { once: true });
        mv.addEventListener(
          "error",
          function () {
            /* model failed: keep the poster; the chips remain the doorway */
            root.classList.add("is-open");
          },
          { once: true },
        );
        /* Some environments never dispatch 'load' even though .loaded flips true
           (render loop throttled/hidden). Poll the property as a fallback. */
        (function waitLoaded(n) {
          if (started) return;
          if (mv.loaded) return start();
          if (n < 300)
            setTimeout(function () {
              waitLoaded(n + 1);
            }, 100);
        })(0);
      }
      try {
        mv.dismissPoster();
      } catch (e) {}
    }

    function showSheet(i) {
      var c = cfg.cyls[i];
      if (!c || !sheet) return;
      sTitle.textContent = i + 1 + " · " + c.t;
      sBody.textContent = c.b;
      sheet.hidden = false;
    }
    function hideSheet() {
      if (sheet) sheet.hidden = true;
    }

    root.addEventListener("click", function (ev) {
      var t = ev.target.closest ? ev.target : null;
      if (!t) return;
      if (t.closest("[data-mnv-openhood]")) {
        openHood();
        return;
      }
      if (t.closest("[data-mnv-shut]")) {
        exitFull();
        return;
      }
      if (t.closest("[data-mnv-closebuy]")) {
        if (buy) buy.hidden = true;
        return;
      }
      if (t.closest("[data-mnv-close]")) {
        hideSheet();
        return;
      }
      var pick = t.closest("[data-mnv-pick]");
      if (pick) {
        if (!opened) openHood();
        showSheet(Number(pick.getAttribute("data-mnv-pick")));
        return;
      }
      if (t.closest("[data-mnv-tojar]")) {
        hideSheet();
        if (!opened) openHood();
        if (mv) {
          mv.setAttribute("camera-orbit", cfg.jarOrbit);
          mv.setAttribute("camera-target", cfg.jarTarget);
        }
        if (buy) buy.hidden = false;
        return;
      }
    });
    /* Numbers are baked into the model; taps resolve by surface ray-hit to the nearest cap. */
    if (mv) {
      var caps = cfg.cyls.map(function (c) {
        var v = (c.p || "").split(/\s+/).map(Number);
        return v.length === 3 && v.every(isFinite) ? v : null;
      });
      mv.addEventListener("click", function (ev) {
        if (!opened) return;
        if (stage && !stage.classList.contains("is-full")) {
          enterFull();
          return;
        }
        var hit = mv.positionAndNormalFromPoint(ev.clientX, ev.clientY);
        if (!hit) return;
        var hp = hit.position,
          best = -1,
          bd = 0.6;
        caps.forEach(function (v, i) {
          if (!v) return;
          var d = Math.sqrt(
            Math.pow(hp.x - v[0], 2) +
              Math.pow(hp.y - v[1], 2) +
              Math.pow(hp.z - v[2], 2),
          );
          if (d < bd) {
            bd = d;
            best = i;
          }
        });
        if (best >= 0) showSheet(best);
      });
    }
    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape") {
        if (sheet && !sheet.hidden) {
          hideSheet();
        } else {
          exitFull();
        }
      }
    });
  });
})();

/* A-204: booklet-steps popup on the protocol box card. */
(function () {
  "use strict";
  document.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t.closest) return;
    if (t.closest("[data-mnv-boxsteps-open]")) {
      var m = document.querySelector("[data-mnv-boxsteps]");
      if (m) m.hidden = false;
      return;
    }
    if (t.closest("[data-mnv-boxsteps-close]")) {
      var m2 = document.querySelector("[data-mnv-boxsteps]");
      if (m2) m2.hidden = true;
      return;
    }
  });
  document.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape") {
      var m = document.querySelector("[data-mnv-boxsteps]");
      if (m && !m.hidden) m.hidden = true;
    }
  });
})();

/* المتجر — the one-page bazaar (A-207, rebuilt A-211): floating pill drawer, live search,
   dual-handle price slider (bounds from the page's own prices), sort by grid order.
   Facet options still read FROM the page - the drawer always mirrors the owner's curation. */
(function () {
  "use strict";
  var root = document.querySelector("[data-shb]");
  if (!root) return;
  var drawer = root.querySelector("[data-shb-drawer]");
  var items = [].slice.call(root.querySelectorAll(".shb-item"));
  var results = root.querySelector("[data-shb-results]");
  var empty = root.querySelector("[data-shb-empty]");
  var counts = [].slice.call(root.querySelectorAll("[data-shb-count]"));
  var search = root.querySelector("[data-shb-search]");
  var sub = parseFloat(root.getAttribute("data-subunits")) || 100;

  function collect(attr) {
    var set = {};
    items.forEach(function (it) {
      (it.getAttribute(attr) || "").split("|").forEach(function (v) {
        v = v.trim();
        if (v) set[v] = 1;
      });
    });
    return Object.keys(set);
  }
  function fill(group, attr) {
    var box = root.querySelector('[data-shb-checks="' + group + '"]');
    var wrap = root.querySelector('[data-shb-group="' + group + '"]');
    var vals = collect(attr);
    if (!vals.length) {
      if (wrap) wrap.hidden = true;
      return;
    }
    vals.forEach(function (v) {
      var l = document.createElement("label");
      var i = document.createElement("input");
      i.type = "checkbox";
      i.value = v;
      i.setAttribute("data-shb-f", group);
      l.appendChild(i);
      l.appendChild(document.createTextNode(v));
      box.appendChild(l);
    });
  }
  fill("origin", "data-origin");
  fill("packing", "data-packing");
  fill("traits", "data-traits");

  /* price slider: bounds from the items themselves */
  var pmins = root.querySelector("[data-shb-pmin]");
  var pmaxs = root.querySelector("[data-shb-pmax]");
  var rfill = root.querySelector("[data-shb-rfill]");
  var rminL = root.querySelector("[data-shb-rmin]");
  var rmaxL = root.querySelector("[data-shb-rmax]");
  var prices = items
    .map(function (it) {
      return parseFloat(it.getAttribute("data-price")) / sub;
    })
    .filter(isFinite);
  /* A-257: an empty shelf (all products deleted) gave Math.min([])=Infinity → NaN labels. */
  var LO = prices.length ? Math.floor(Math.min.apply(null, prices)) : 0;
  var HI = prices.length ? Math.ceil(Math.max.apply(null, prices)) : 0;
  pmins.value = LO;
  pmaxs.value = HI;
  var track2 = root.querySelector("[data-shb-track2]");
  var hMin = root.querySelector('[data-shb-handle="min"]');
  var hMax = root.querySelector('[data-shb-handle="max"]');
  var isRTL = getComputedStyle(track2).direction === "rtl";
  /* Committed-currency labels (audit T2): filtering stays in KWD internally;
     only the display converts, whole numbers - a bound is approximate by nature. */
  var shbRangeEl = root.querySelector("[data-shb-range]");
  var RATE = shbRangeEl
    ? parseFloat(shbRangeEl.getAttribute("data-shb-rate")) || 0
    : 0;
  /* A-389: the bound labels disagreed with the product cards behind them - the slider
     read "0.0 — 73.0 KWD" while the cards read "0.500 KD" and "73.000 KD". Same screen,
     same currency, two precisions and two names. Both halves are fixed here: three
     decimals for the KWD bounds (what this store's money format prints), and the
     currency suffix derived from that format rather than the ISO code. The token and
     its hand-padded zero are consumed together, the same rule used everywhere else in
     this file. Converted markets keep whole numbers - a converted bound is approximate
     by nature, which is the existing deliberate choice. */
  /* T-012 follow-up: on a per-country store (data-shb-native) the bounds are already
     the store's own money — no rate, and the label keeps its server-rendered
     locale-aware symbol (mkt-amount) instead of the admin money-format suffix,
     which only knows one language. Bounds print two decimals there (native
     currencies send two); Kuwait keeps its three-decimal format and suffix. */
  var shbNative = !!(shbRangeEl && shbRangeEl.hasAttribute("data-shb-native"));
  if (shbRangeEl && RATE <= 0 && !shbNative) {
    var shbCurEl = shbRangeEl.querySelector("[data-shb-cur]");
    var shbMF = shbRangeEl.getAttribute("data-money-format") || "";
    var shbSuffix = shbMF.replace(/\{\{\s*amount[^}]*\}\}0?/g, "").trim();
    if (shbCurEl && shbSuffix) shbCurEl.textContent = shbSuffix;
  }
  function syncRange() {
    var a = parseFloat(pmins.value),
      b = parseFloat(pmaxs.value);
    /* Same decimal rule as the meter: a dinar store's own format carries the third
       decimal, so its filter bounds read 0.650 - 90.100 like the cards behind them,
       not 0.65 - 90.10. Kuwait already printed three via the non-native arm. */
    var shbPad3 = /\}\}\s*0/.test(shbRangeEl ? shbRangeEl.getAttribute("data-money-format") || "" : "");
    var disp = function (v) {
      if (RATE > 0) return String(Math.round(v * RATE));
      return v.toFixed(shbNative && !shbPad3 ? 2 : 3);
    };
    rminL.textContent = disp(a);
    rmaxL.textContent = disp(b);
    var span = HI - LO || 1;
    var s1 = ((a - LO) / span) * 100,
      s2 = ((b - LO) / span) * 100;
    rfill.style.insetInlineStart = s1 + "%";
    rfill.style.inlineSize = s2 - s1 + "%";
    hMin.style.insetInlineStart = s1 + "%";
    hMax.style.insetInlineStart = s2 + "%";
  }
  function valFromX(x) {
    var r = track2.getBoundingClientRect();
    var frac = isRTL ? (r.right - x) / r.width : (x - r.left) / r.width;
    frac = Math.max(0, Math.min(1, frac));
    return Math.round((LO + frac * (HI - LO)) * 10) / 10;
  }
  function dragHandle(which, ev) {
    var el = which === "min" ? hMin : hMax;
    try {
      el.setPointerCapture(ev.pointerId);
    } catch (e) {}
    function move(e) {
      var v = valFromX(e.clientX);
      if (which === "min") pmins.value = Math.min(v, parseFloat(pmaxs.value));
      else pmaxs.value = Math.max(v, parseFloat(pmins.value));
      syncRange();
    }
    function up() {
      el.removeEventListener("pointermove", move);
      el.removeEventListener("pointerup", up);
      el.removeEventListener("pointercancel", up);
    }
    el.addEventListener("pointermove", move);
    el.addEventListener("pointerup", up);
    el.addEventListener("pointercancel", up);
    move(ev);
  }
  hMin.addEventListener("pointerdown", function (ev) {
    ev.preventDefault();
    dragHandle("min", ev);
  });
  hMax.addEventListener("pointerdown", function (ev) {
    ev.preventDefault();
    dragHandle("max", ev);
  });
  track2.addEventListener("pointerdown", function (ev) {
    if (ev.target === hMin || ev.target === hMax) return;
    var v = valFromX(ev.clientX);
    var dMin = Math.abs(v - parseFloat(pmins.value)),
      dMax = Math.abs(v - parseFloat(pmaxs.value));
    dragHandle(dMin <= dMax ? "min" : "max", ev);
  });
  syncRange();

  function checked(group) {
    return [].slice
      .call(root.querySelectorAll('[data-shb-f="' + group + '"]:checked'))
      .map(function (i) {
        return i.value;
      });
  }
  /* A-256: the bazaar search matched raw, so Arabic variants (diacritics, أ/إ/آ, ة/ه, ى/ي,
     the leading ال article) all missed — unlike the header search. Fold both the query and
     the title the same way before comparing, and strip a leading ال from each so سدر ↔ السدر. */
  function shbFold(s) {
    return String(s || "")
      .replace(/[ً-ْٰـ]/g, "")
      .replace(/[أإآٱ]/g, "ا")
      .replace(/ة/g, "ه")
      .replace(/ى/g, "ي")
      .replace(/ؤ/g, "و")
      .replace(/ئ/g, "ي")
      .replace(/[٠-٩]/g, function (d) {
        return String.fromCharCode(d.charCodeAt(0) - 0x0660 + 48);
      })
      .replace(/^ال/, "")
      .toLowerCase();
  }
  function sortMode() {
    var r = root.querySelector("[data-shb-sort]:checked");
    return r ? r.value : "";
  }
  function apply() {
    var a = parseFloat(pmins.value) * sub,
      b = parseFloat(pmaxs.value) * sub;
    var priceActive = a > LO * sub || b < HI * sub;
    var q = ((search && search.value) || "").trim();
    var qf = q ? shbFold(q) : "";
    var org = checked("origin"),
      pack = checked("packing"),
      tr = checked("traits");
    var bestOnly = root.querySelector("[data-shb-best]").checked;
    var sort = sortMode();
    var active = !!(
      org.length ||
      pack.length ||
      tr.length ||
      bestOnly ||
      priceActive ||
      q ||
      sort
    );
    var n = 0,
      seen = {};
    items.forEach(function (it) {
      var ok = true;
      var price = parseFloat(it.getAttribute("data-price"));
      if (priceActive && (price < a || price > b)) ok = false;
      if (
        ok &&
        qf &&
        shbFold(it.getAttribute("data-title") || "").indexOf(qf) < 0
      )
        ok = false;
      if (ok && org.length && org.indexOf(it.getAttribute("data-origin")) < 0)
        ok = false;
      if (
        ok &&
        pack.length &&
        pack.indexOf(it.getAttribute("data-packing")) < 0
      )
        ok = false;
      if (ok && tr.length) {
        var mine = (it.getAttribute("data-traits") || "").split("|");
        ok = tr.some(function (t) {
          return mine.indexOf(t) >= 0;
        });
      }
      if (ok && bestOnly && it.getAttribute("data-best") !== "1") ok = false;
      if (ok && active) {
        var h = it.getAttribute("data-handle");
        if (seen[h]) ok = false;
        else seen[h] = 1;
      }
      it.classList.toggle("is-hidden", !ok);
      if (ok) n++;
      var ord = 0;
      if (active) {
        if (sort === "asc") ord = Math.round(price);
        if (sort === "desc") ord = -Math.round(price);
      }
      it.style.order = active ? ord : "";
    });
    root.classList.toggle("is-filtering", active);
    var nf =
      org.length +
      pack.length +
      tr.length +
      (bestOnly ? 1 : 0) +
      (priceActive ? 1 : 0) +
      (q ? 1 : 0) +
      (sort ? 1 : 0);
    counts.forEach(function (cb) {
      cb.hidden = !nf;
      cb.textContent = nf;
    });
    results.hidden = !active;
    /* A-389: translated template, not a hardcoded Arabic literal - see the note in
       shop-bazaar.liquid. Falls back to the bare number if the attribute is missing,
       which is wrong in no language. */
    results.textContent = active
      ? (results.getAttribute("data-str-results") || "{n}").replace("{n}", n)
      : "";
    empty.hidden = !(active && n === 0);
  }
  function closeDrawer() {
    root.querySelector(".shb-drawer-back").classList.remove("open");
    root.querySelector(".shb-drawer-in").classList.remove("open");
    root.classList.remove("drawer-open");
    document.documentElement.classList.remove("shb-lock");
    if (root.classList.contains("is-filtering"))
      window.scrollTo({ top: 0, behavior: "auto" });
  }
  function clearAll() {
    root
      .querySelectorAll("[data-shb-f], [data-shb-best]")
      .forEach(function (i) {
        i.checked = false;
      });
    var d = root.querySelector('[data-shb-sort][value=""]');
    if (d) d.checked = true;
    pmins.value = LO;
    pmaxs.value = HI;
    syncRange();
    if (search) search.value = "";
    items.forEach(function (it) {
      it.classList.remove("is-hidden");
      it.style.order = "";
    });
    root.classList.remove("is-filtering");
    counts.forEach(function (cb) {
      cb.hidden = true;
    });
    results.hidden = true;
    empty.hidden = true;
    closeDrawer();
  }
  var dback = root.querySelector(".shb-drawer-back");
  var dpanel = root.querySelector(".shb-drawer-in");
  function openDrawer() {
    dback.classList.add("open");
    dpanel.classList.add("open");
    root.classList.add("drawer-open");
    document.documentElement.classList.add("shb-lock");
  }
  root.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t.closest) return;
    if (t.closest("[data-shb-open]")) {
      openDrawer();
      return;
    }
    if (t.closest("[data-shb-close]")) {
      closeDrawer();
      return;
    }
    if (t.closest("[data-shb-apply]")) {
      apply();
      writeUrl();
      closeDrawer();
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    if (t.closest("[data-shb-clear]")) {
      clearAll();
      writeUrl();
      return;
    }
  });
  if (search) {
    var deb;
    search.addEventListener("input", function () {
      clearTimeout(deb);
      deb = setTimeout(function () {
        apply();
        writeUrl();
      }, 160);
    });
  }
  document.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape" && dpanel.classList.contains("open")) closeDrawer();
  });

  /* the main menu drawer's swipe, verbatim: 8px horizontal intent, finger-follow toward
     the hidden side only, preventDefault while dragging, commit past 90px, spring back. */
  var shSX = 0,
    shSY = 0,
    shDrag = false,
    shWent = 0,
    shDir = getComputedStyle(dpanel).direction === "rtl" ? 1 : -1;
  dpanel.addEventListener(
    "touchstart",
    function (e) {
      if (!dpanel.classList.contains("open")) return;
      /* touches that begin on the price slider belong to the slider - never to the swipe */
      if (e.target.closest && e.target.closest("[data-shb-track2]")) {
        shSX = null;
        return;
      }
      shSX = e.touches[0].clientX;
      shSY = e.touches[0].clientY;
      shDrag = false;
      shWent = 0;
    },
    { passive: true },
  );
  dpanel.addEventListener(
    "touchmove",
    function (e) {
      if (!dpanel.classList.contains("open") || shSX === null) return;
      var dx = e.touches[0].clientX - shSX,
        dy = e.touches[0].clientY - shSY;
      if (!shDrag) {
        if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
        shDrag = true;
        dpanel.classList.add("shb-drag");
      }
      shWent = Math.max(0, dx * shDir);
      dpanel.style.transform = "translateX(" + shWent * shDir + "px)";
      e.preventDefault();
    },
    { passive: false },
  );
  function shSwipeEnd() {
    if (!shDrag) return;
    shDrag = false;
    dpanel.classList.remove("shb-drag");
    dpanel.style.transform = "";
    if (shWent > 90) closeDrawer();
  }
  dpanel.addEventListener("touchend", shSwipeEnd, { passive: true });
  dpanel.addEventListener("touchcancel", shSwipeEnd, { passive: true });

  /* back-to-top: appears after a screen of scrolling, opposite corner from the pill */
  var topBtn = root.querySelector("[data-shb-top]");
  if (topBtn) {
    var topTick = false;
    function topCheck() {
      topBtn.classList.toggle(
        "show",
        window.scrollY > window.innerHeight * 0.8,
      );
      topTick = false;
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!topTick) {
          topTick = true;
          requestAnimationFrame(topCheck);
        }
      },
      { passive: true },
    );
    topBtn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    topCheck();
  }

  /* A-590: the applied filters live in the URL, so a filtered bazaar is a link - the owner
     applies a filter, copies the address bar, and that is the ad's landing page (research
     record ops/proposals/bazaar-deep-links/RESEARCH-2026-10-25.md). Written on apply /
     search / clear with replaceState (never pushState: no back-button trap on an ad
     landing), read once on load after the facets are built. Only these keys are ours;
     every other key (utm_*, fbclid, ttclid, ScCid, ...) is kept exactly where it was.
     Names stay clear of Shopify's reserved ones (q, page, sort_by, view, filter.*, ...).
     Multi-select is a repeated key (traits=a&traits=b), never a comma. A value that
     matches no checkbox is ignored - so an Arabic link opened on /en (the trait values
     are translated there) shows the whole bazaar, never an empty grid. min/max are in
     the store's own money unit, exactly what the slider prints, clamped to the page's
     bounds. Inside the theme editor nothing is written. Everything is wrapped so a
     browser without URLSearchParams keeps today's drawer unchanged. */
  var SHB_KEYS = [
    "traits",
    "origin",
    "packing",
    "min",
    "max",
    "sort",
    "best",
    "find",
  ];
  function shbParams() {
    try {
      return new URLSearchParams(location.search);
    } catch (e) {
      return null;
    }
  }
  /* A-591: the link carries an English WORD, never the Arabic value - ads need a plain
     link, and one link must work on the Arabic page and on /en. The Arabic page cannot
     read the English translation (Liquid sees one locale), so the bazaar section holds
     the pairs in its "Link names" setting, one line each: غذاء الملكات = Royal Jelly.
     The English becomes the word: lowercase, every space or symbol to "_" (royal_jelly).
     On /en a value that is already English yields the same word with no setting at all.
     A value with no English anywhere keeps today's behaviour (the value itself), so a
     missing line never breaks a filter - and old Arabic links still read. */
  function shbSlug(s) {
    var t = String(s || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    return t || null;
  }
  var SHB_NAMES = {};
  String(root.getAttribute("data-shb-names") || "")
    .split(/\r?\n/)
    .forEach(function (line) {
      var i = line.indexOf("=");
      if (i < 0) return;
      var a = line.slice(0, i).trim(),
        w = shbSlug(line.slice(i + 1));
      if (a && w) SHB_NAMES[shbFold(a)] = w;
    });
  function shbWord(v) {
    return SHB_NAMES[shbFold(v)] || shbSlug(v) || v;
  }
  function shbTick(group, wanted) {
    var boxes = [].slice.call(
      root.querySelectorAll('[data-shb-f="' + group + '"]'),
    );
    wanted.forEach(function (w) {
      var hit = null,
        ww = shbSlug(w);
      if (ww)
        boxes.some(function (b) {
          if (shbWord(b.value) === ww) hit = b;
          return !!hit;
        });
      if (!hit)
        boxes.some(function (b) {
          if (b.value === w) hit = b;
          return !!hit;
        });
      if (!hit) {
        var fw = shbFold(w);
        boxes.some(function (b) {
          if (shbFold(b.value) === fw) hit = b;
          return !!hit;
        });
      }
      if (hit) hit.checked = true;
    });
  }
  function readUrl() {
    var p = shbParams();
    if (!p) return false;
    var any = false;
    ["traits", "origin", "packing"].forEach(function (g) {
      var v = p.getAll(g);
      if (v.length) {
        any = true;
        shbTick(g, v);
      }
    });
    var s = p.get("sort");
    if (s === "asc" || s === "desc") {
      var r = root.querySelector('[data-shb-sort][value="' + s + '"]');
      if (r) {
        r.checked = true;
        any = true;
      }
    }
    if (p.get("best") === "1") {
      root.querySelector("[data-shb-best]").checked = true;
      any = true;
    }
    var mn = parseFloat(p.get("min")),
      mx = parseFloat(p.get("max"));
    if (isFinite(mn) || isFinite(mx)) {
      if (isFinite(mn)) pmins.value = Math.min(HI, Math.max(LO, mn));
      if (isFinite(mx)) pmaxs.value = Math.max(LO, Math.min(HI, mx));
      if (parseFloat(pmins.value) > parseFloat(pmaxs.value)) {
        pmins.value = LO;
        pmaxs.value = HI;
      }
      syncRange();
      any = true;
    }
    var f = (p.get("find") || "").trim();
    if (f && search) {
      search.value = f;
      any = true;
    }
    return any;
  }
  function writeUrl() {
    if (window.Shopify && window.Shopify.designMode) return;
    var p = shbParams();
    if (!p || !window.history || !history.replaceState) return;
    SHB_KEYS.forEach(function (k) {
      p.delete(k);
    });
    ["traits", "origin", "packing"].forEach(function (g) {
      checked(g).forEach(function (v) {
        p.append(g, shbWord(v));
      });
    });
    var a = parseFloat(pmins.value),
      b = parseFloat(pmaxs.value);
    if (a > LO) p.set("min", String(a));
    if (b < HI) p.set("max", String(b));
    var s = sortMode();
    if (s) p.set("sort", s);
    if (root.querySelector("[data-shb-best]").checked) p.set("best", "1");
    var q = ((search && search.value) || "").trim();
    if (q) p.set("find", q);
    /* URLSearchParams writes a space as "+"; %20 reads the same and copies cleaner */
    var qs = p.toString().replace(/\+/g, "%20");
    try {
      history.replaceState(
        history.state,
        "",
        location.pathname + (qs ? "?" + qs : "") + location.hash,
      );
    } catch (e) {}
  }
  try {
    if (readUrl()) apply();
  } catch (e) {}
})();

/* A-208: /collections/all is a built-in route that cannot be deleted; the owner retired
   it for the bazaar. Forward instantly, locale prefixes included. A-590: the query string
   and hash ride along, so a filtered link written against /collections/all still lands
   filtered. */
(function () {
  if (
    /\/collections\/all(\/|$|\?)/.test(
      window.location.pathname + window.location.search,
    )
  ) {
    window.location.replace(
      window.location.pathname.replace(/collections\/all.*/, "collections") +
        window.location.search +
        window.location.hash,
    );
  }
})();

/* A-209: bazaar chips - smooth scroll + scroll-spy highlight. */
(function () {
  "use strict";
  var bar = document.querySelector("[data-shb-chips]");
  if (!bar) return;
  var chips = [].slice.call(bar.querySelectorAll("[data-shb-chip]"));
  chips.forEach(function (chip) {
    chip.addEventListener("click", function (ev) {
      ev.preventDefault();
      var t = document.getElementById(chip.getAttribute("data-shb-chip"));
      if (t) t.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          chips.forEach(function (c) {
            c.classList.toggle(
              "on",
              c.getAttribute("data-shb-chip") === e.target.id,
            );
          });
          var on = bar.querySelector(".shb-chip.on");
          if (on && on.scrollIntoView)
            on.scrollIntoView({
              block: "nearest",
              inline: "center",
              behavior: "smooth",
            });
        });
      },
      { rootMargin: "-15% 0px -70% 0px" },
    );
    chips.forEach(function (chip) {
      var t = document.getElementById(chip.getAttribute("data-shb-chip"));
      if (t) io.observe(t);
    });
  }
})();

/* A-210: bazaar slides - dot sync + tap navigation. */
(function () {
  "use strict";
  var wrap = document.querySelector("[data-shb-slides]");
  if (!wrap) return;
  var track = wrap.querySelector("[data-shb-track]");
  var dots = [].slice.call(wrap.querySelectorAll("[data-shb-dot]"));
  if (!track || !dots.length) return;
  function setOn(i) {
    dots.forEach(function (d, j) {
      d.classList.toggle("on", j === i);
    });
  }
  setOn(0);
  track.addEventListener(
    "scroll",
    function () {
      var w = track.clientWidth;
      if (w) setOn(Math.round(Math.abs(track.scrollLeft) / w));
    },
    { passive: true },
  );
  dots.forEach(function (d, i) {
    d.addEventListener("click", function () {
      /* A-257: offsetLeft is an LTR-origin offset - on the RTL storefront scrollLeft runs
         0→negative, so tapping a dot jumped to the wrong slide. Mirror it like the hero. */
      var dir = getComputedStyle(track).direction === "rtl" ? -1 : 1;
      track.scrollTo({ left: dir * i * track.clientWidth, behavior: "smooth" });
    });
  });
})();

/* A-228: PDP pay marks + quick buy ------------------------------------------------ */
(function () {
  var host = document.querySelector("[data-pdp-pay]");
  if (host) {
    /* Same source of truth as the cart drawer: the footer's icon row. The owner's
       "also show in the cart drawer" ticks are honoured here too; fallback to the
       first seven when he has ticked none - identical logic, second surface. */
    var src = document.querySelector(".ficons-list");
    if (src) {
      var picked = [].slice.call(
        src.querySelectorAll(".ficons-i[data-cart-icon]"),
      );
      var items = (
        picked.length
          ? picked
          : [].slice.call(src.querySelectorAll(".ficons-i"))
      ).slice(0, 7);
      items.forEach(function (li) {
        var img = li.querySelector("img");
        if (!img) return;
        var el = document.createElement("li");
        var c = img.cloneNode(true);
        c.removeAttribute("loading");
        c.removeAttribute("width");
        c.removeAttribute("height");
        el.appendChild(c);
        host.appendChild(el);
      });
      host.style.setProperty("--n", Math.min(host.children.length, 7) || 1);
      var wrap = document.querySelector("[data-pdp-pay-wrap]");
      if (wrap) wrap.hidden = !host.children.length;
    }
  }
  /* A-389: THE BFCACHE TRAP - the same one the locale modal's تطبيق button already
     guards against further down this file. Tap اشترِ الآن, reach checkout, change your
     mind, press Back: the browser restores this page exactly as it left it, with the
     button still `disabled`. There is no :disabled styling on it, so it still looks
     live - the customer taps a control that cannot answer and nothing explains why.
     Only the pressed button is affected (the other tiers, add-to-cart and the drawer
     all still work, and the item is already in the server cart), which is precisely why
     it reads as the store being broken rather than as a state. */
  window.addEventListener("pageshow", function () {
    document
      .querySelectorAll("[data-buy-now][disabled],[data-qoffer-buy][disabled]")
      .forEach(function (b) {
        b.disabled = false;
      });
  });
  /* Quick buy: the form's variant at the form's quantity, straight to checkout.
     On any failure the button re-enables and the normal add-to-cart path takes over. */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-buy-now]");
    if (!b || b.disabled) return;
    var f = document.querySelector("form[data-atc-form]");
    if (!f) return;
    var id = Number(f.querySelector("[name=id]").value);
    var qi = f.querySelector("[name=quantity]");
    var qty = qi ? Math.max(1, Math.round(Number(qi.value) || 1)) : 1;
    /* A-257: prefix with the locale root so an /en shopper isn't dropped into the Arabic
       cart + checkout. Shopify.routes.root is '/en/' on the English storefront, '/' otherwise. */
    var LR = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    b.disabled = true;
    fetch(LR + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty }),
    })
      .then(function (r) {
        /* AUDIT B-19: an HTTP error (stock cap 422) means the server
           ANSWERED - the marker keeps the catch from re-POSTing natively
           onto Shopify's raw error page. */
        if (!r.ok) throw { handled: true };
        /* Kuwait-only step 1: the pre-checkout address page is retired - every
           buy-now path goes straight to the native checkout, which is now the
           single address surface. */
        window.location.href = LR + "checkout";
      })
      .catch(function (x) {
        b.disabled = false;
        /* AUDIT B-19: a HANDLED failure (stock cap 422 - ajaxAdd already
           surfaced the localized reason) must not fall through to a native
           POST that lands on Shopify's raw error page. The native resubmit
           stays for genuine network failures only. */
        if (x && x.handled) return;
        if (f.requestSubmit) f.requestSubmit();
        else f.submit();
      });
  });
})();

/* A-239: quantity-offer cards set the buy form's quantity ---------------------- */
(function () {
  function qoSelect(b) {
    var qi = document.querySelector("form[data-atc-form] [name=quantity]");
    if (!qi) return;
    qi.value = Math.max(1, Number(b.dataset.qoffer) || 1);
    qi.dispatchEvent(new Event("change", { bubbles: true }));
    document.querySelectorAll("[data-qoffer]").forEach(function (x) {
      x.classList.remove("sel");
    });
    b.classList.add("sel");
  }
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-qoffer]");
    if (b) qoSelect(b);
  });
  /* A-389: these cards are `<div role="button" tabindex="0">` - they ANNOUNCE as
     buttons and take a focus stop, so a keyboard user lands on one and presses Enter,
     and nothing happens. An element that claims to be a button has to behave like one.
     Space is included and its default scroll suppressed, matching native button
     behaviour. (The discount itself was still reachable via the real quantity stepper
     and the real <button> inside the card - so nobody was blocked; the element was
     simply lying about what it was.) */
  document.addEventListener("keydown", function (ev) {
    if (ev.key !== "Enter" && ev.key !== " " && ev.key !== "Spacebar") return;
    var b = ev.target.closest && ev.target.closest("[data-qoffer]");
    if (!b) return;
    /* Never swallow a key meant for a real control nested inside the card. */
    if (ev.target.closest("button,a,input,select,textarea")) return;
    ev.preventDefault();
    qoSelect(b);
  });
})();

/* A-240: per-card quick buy - that tier's quantity, straight to checkout ---------- */
(function () {
  document.addEventListener(
    "click",
    function (ev) {
      var b = ev.target.closest("[data-qoffer-buy]");
      if (!b || b.disabled) return;
      ev.stopPropagation();
      var f = document.querySelector("form[data-atc-form]");
      if (!f) return;
      var id = Number(f.querySelector("[name=id]").value);
      var qty = Math.max(1, Number(b.dataset.qofferBuy) || 1);
      var LR =
        (window.Shopify && Shopify.routes && Shopify.routes.root) ||
        "/"; /* A-257: keep /en shoppers in /en */
      b.disabled = true;
      /* A-389: SET the quantity, do not ADD to it.
         This posted to /cart/add.js, which is additive - so a card labelled "اشترِ 3"
         tapped with 2 of the same jar already in the cart sent the customer to checkout
         with FIVE, no drawer and no confirmation in between. The price promise still
         held (Shopify grants the best eligible tier), but Shopify's checkout does not
         allow line-quantity edits, so the only recovery was to abandon, go back, fix the
         cart and start again - and a physical Kuwait delivery makes the ones who don't
         notice into real returns.
         /cart/update.js keyed by VARIANT ID is absolute: it sets that variant's total
         quantity to exactly what the card promises, whatever was there before. */
      var qoUpdates = {};
      qoUpdates[id] = qty;
      fetch(LR + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates: qoUpdates }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          /* Kuwait-only step 1: straight to native checkout, like every other
             buy path. */
          window.location.href = LR + "checkout";
        })
        .catch(function () {
          b.disabled = false;
        });
    },
    true,
  );
})();

/* A-262: editorial share row. Every URL is built from location.href at click time, so the
     links survive a future domain change - nothing is hardcoded to the myshopify host. */
(function () {
  document.addEventListener("click", function (e) {
    var el =
      e.target && e.target.closest ? e.target.closest("[data-share]") : null;
    if (!el) return;
    e.preventDefault();
    var u = encodeURIComponent(location.href);
    var t = encodeURIComponent(document.title);
    var kind = el.getAttribute("data-share");
    var url = "";
    if (kind === "x")
      url = "https://twitter.com/intent/tweet?url=" + u + "&text=" + t;
    else if (kind === "pin")
      url = "https://pinterest.com/pin/create/button/?url=" + u;
    else if (kind === "fb")
      url = "https://www.facebook.com/sharer/sharer.php?u=" + u;
    else if (kind === "wa") url = "https://wa.me/?text=" + t + "%20" + u;
    else if (kind === "more") {
      if (navigator.share)
        navigator.share({ title: document.title, url: location.href });
      return;
    } else if (kind === "copy") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(location.href).then(function () {
          var d = el.getAttribute("data-done");
          if (d) el.textContent = d;
        });
      }
      return;
    }
    if (url) window.open(url, "_blank", "noopener");
  });
})();

/* A-275: the /search PAGE runs the SAME Arabic-folding matcher as the search drawer.
     Shopify's server search cannot match through the definite article (measured: q=سدر
     returned zero against a catalogue titled عسل السدر…), which is why the drawer got its
     own index — and why the page a customer landed on stayed blind while the bar above it
     worked. The server-rendered grid and pagination remain as the no-JS fallback; when
     this runs it re-renders the grid from the same /products.json index with the same
     folding, so the bar and the page can never disagree again. norm()/haystack() are
     duplicated from the drawer module on purpose — that code is closure-scoped, and
     sharing state across the seams of this file has already caused one bug (see the
     lastY collision note above). If the folding rules ever change, change BOTH. */
(function () {
  var host = document.querySelector("[data-ssearch]");
  if (!host) return;
  var q = "";
  try {
    q = new URLSearchParams(location.search).get("q") || "";
  } catch (e) {
    return;
  }
  if (!q.trim()) return;
  var LR = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function norm(s) {
    return String(s || "")
      .replace(/[ً-ْٰـ]/g, "")
      .replace(/[أإآٱ]/g, "ا")
      .replace(/ة/g, "ه")
      .replace(/ى/g, "ي")
      .replace(/ؤ/g, "و")
      .replace(/ئ/g, "ي")
      .replace(/[٠-٩]/g, function (d) {
        return String.fromCharCode(d.charCodeAt(0) - 0x0660 + 48);
      })
      .toLowerCase();
  }
  function haystack(p) {
    var base = norm(
      [p.title, p.product_type, p.vendor, (p.tags || []).join(" ")].join(" "),
    );
    return base + " " + base.replace(/(^|\s)ال/g, "$1");
  }
  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  /* Money: the {{amount}} token AND the format's hand-padded third-decimal zero are
       consumed together — /products.json already returns all three KWD decimals. */
  var mf = host.getAttribute("data-money-format") || "{{amount}} KD";
  function money(dec) {
    /* A-389: use the ONE shared formatter the main closure publishes. The local
       fallback below is only for the case where that module never ran, and it now uses
       the SAME regex - `0*` not `0?`, and the wider token class - so the two cannot
       answer differently. */
    if (window.T3B && typeof window.T3B.money === "function")
      return window.T3B.money(dec);
    return mf.replace(/\{\{\s*amount[^}]*\}\}0*/, dec);
  }

  /* Committed-currency markets: the server grid is already priced in the local
       currency via mkt-price; /products.json can only price in KWD (metafields are
       not in that payload). Do not overwrite truth with KWD. (audit T1) */
  /* This module sits OUTSIDE the main closure - main-scope vars like T do not
       exist here; referencing them threw and killed the whole module (A-351 fix).
       Read the global config directly. */
  if (window.T3B && window.T3B.mktLocal) return;

  /* A-389: AND across whitespace-separated terms, exactly as the drawer's run() does.
     Testing the whole query as ONE contiguous string meant word order decided the answer:
     "سدر جبلي" matched and "جبلي سدر" — the same two words — matched nothing. */
  var terms = norm(q.trim()).split(/\s+/).filter(Boolean);
  fetch(LR + "products.json?limit=250")
    .then(function (r) {
      if (!r.ok) throw new Error("index fetch failed");
      return r.json();
    })
    .then(function (j) {
      var hits = (j.products || []).filter(function (p) {
        var hay = haystack(p);
        for (var i = 0; i < terms.length; i++)
          if (hay.indexOf(terms[i]) === -1) return false;
        return true;
      });
      var grid = host.querySelector("[data-ssearch-grid]");
      if (!grid) return;
      function card(p) {
        var v = (p.variants || [])[0] || {};
        var img = (p.images || [])[0] || {};
        var imgSrc = img.src
          ? img.src.replace(/(\.[a-z]+)(\?|$)/i, "_500x$1$2")
          : "";
        var url = LR + "products/" + p.handle;
        return (
          '<article class="pcard">' +
          '<div class="ph"><a href="' +
          esc(url) +
          '" aria-label="' +
          esc(p.title) +
          '">' +
          (imgSrc
            ? '<img src="' +
              esc(imgSrc) +
              '" alt="' +
              esc(p.title) +
              '" loading="lazy">'
            : "") +
          "</a></div>" +
          (v.id && v.available !== false
            ? '<button class="qa" type="button" data-quick-add="' +
              esc(v.id) +
              '" data-url="' +
              esc(url) +
              '">' +
              esc(host.getAttribute("data-str-add") || "+") +
              " +</button>"
            : "") +
          '<div class="inf"><a class="t" href="' +
          esc(url) +
          '">' +
          esc(p.title) +
          "</a>" +
          '<div class="pr"><b>' +
          esc(money(v.price || "")) +
          "</b></div></div>" +
          "</article>"
        );
      }

      /* A-389 — ADD TO THE SERVER'S ANSWER, NEVER REPLACE IT.
         This module used to overwrite the grid with its own hits, and to overwrite it
         with "لا توجد نتائج" when it had none. Both destroyed real results: the JS index
         covers title/product_type/vendor/tags, while Shopify ALSO matches the product
         DESCRIPTION — and on this catalogue product_type is empty store-wide and the tags
         are cat:NNN bookkeeping, so the index is effectively title-only.
         Measured on the live store before the fix: /search?q=سوداني rendered
         "1 result found" in the <title> with the product card present in the HTML, and
         this code replaced it with the empty-state. The server's answer is never wrong,
         only incomplete through the definite article — so keep every card it rendered and
         append the ones its folding lost. */
      var serverCards = grid.querySelectorAll('a[href*="/products/"]');
      var seen = {};
      Array.prototype.forEach.call(serverCards, function (a) {
        var m = (a.getAttribute("href") || "").match(/\/products\/([^?#/]+)/);
        if (!m) return;
        var h = m[1];
        try {
          h = decodeURIComponent(h);
        } catch (e) {
          /* a malformed escape - match on the raw handle instead */
        }
        seen[h] = true;
      });
      var fresh = hits.filter(function (p) {
        return !seen[p.handle];
      });

      if (!serverCards.length) {
        /* The server found nothing and rendered its empty-state paragraph. Replacing
           that is safe - there is no result to lose. If we have nothing either, the
           server's own wording stays; it is the honest answer. */
        if (fresh.length) grid.innerHTML = fresh.map(card).join("");
      } else if (fresh.length) {
        grid.insertAdjacentHTML("beforeend", fresh.map(card).join(""));
      }

      /* The pagination is the SERVER's, and pages 2+ hold server results this module
         never fetched. It used to be hidden unconditionally, which stranded them. */
      var pag = host.querySelector("[data-ssearch-pag]");
      var st = host.querySelector("[data-ssearch-count]");
      var shown = grid.querySelectorAll("article.pcard").length;
      /* Only claim a count when the entire answer is on this page. With pagination
         present the grid holds 12 of N and any number printed here would be false. */
      if (st && !pag && shown) {
        st.textContent = (
          host.getAttribute("data-str-results") || "{n}"
        ).replace("{n}", shown);
        st.hidden = false;
      }
    })
    .catch(function () {
      /* server-rendered results stay — the fallback IS the page */
    });
})();

/* A-520: the announcement bar is pinned and the header pins right under it, at --topbar-h.
     The section sets that once, before the first paint; this keeps it true when the bar's
     height changes afterwards (a sentence that wraps, a rotated phone). Measured, like
     --cbar-lift and --wafab-lift - never assumed. A bar that is not pinned is left alone. */
(function () {
  var bar = document.querySelector(".announce");
  var sec = bar && bar.closest ? bar.closest(".shopify-section") : null;
  if (!sec || getComputedStyle(sec).position !== "sticky") return;
  function fit() {
    document.documentElement.style.setProperty(
      "--topbar-h",
      Math.round(sec.getBoundingClientRect().height) + "px",
    );
  }
  fit();
  if (window.ResizeObserver) new ResizeObserver(fit).observe(sec);
  else window.addEventListener("resize", fit);
})();

/* A-278: keep the WhatsApp button above whatever owns the bottom edge. MEASURED, not
     assumed - same discipline as --cbar-lift: each bar's intrusion from the viewport bottom
     is read from its rect whenever the cart changes or the window resizes, and the tallest
     wins. TWO bars, not one (A-473): the product page's sticky add-to-cart shows on phones
     even with an empty cart, and the button sat on top of it - in the left corner that is
     the add-to-cart button itself. */
(function () {
  var fab = document.querySelector(".wafab");
  if (!fab) return;
  var pending = false;
  function lift() {
    pending = false;
    var h = 0;
    [".cbar", ".stickyatc"].forEach(function (sel) {
      var bar = document.querySelector(sel);
      if (!bar) return;
      var cs = getComputedStyle(bar);
      if (cs.display === "none" || cs.visibility === "hidden") return;
      var top = bar.getBoundingClientRect().top;
      if (top < window.innerHeight) h = Math.max(h, Math.round(window.innerHeight - top) + 10);
    });
    document.documentElement.style.setProperty("--wafab-lift", h + "px");
  }
  /* Plain debounced timer, NOT requestAnimationFrame: rAF stalls in backgrounded and
       hidden tabs (and never fires in headless panes), and nothing here needs frame
       timing - the measurement just has to run shortly after layout settles. */
  function queue() {
    if (pending) return;
    pending = true;
    setTimeout(lift, 300);
  }
  document.addEventListener("t3b:cart", queue);
  window.addEventListener("resize", queue);
  window.addEventListener("pageshow", queue);
  /* Once now, so the button never starts on top of a bar and hops up 0.3 s later; the
       queued run is the settle re-check. */
  lift();
  queue();
})();

/* Press-and-hold to move (owner 2026-09-11: "give me the ability of moving it around if I
     hold on to it"). Holding the button ~0.35 s enters move mode (it swells, the glyph stops
     ringing, a short buzz where the device has one); the drag then follows the finger; a
     plain tap still opens WhatsApp, and a swipe that starts on it is not a hold. The spot is
     kept per device (localStorage): a fraction of the width, plus a PIXEL distance from the
     BOTTOM edge (owner 2026-09-12: anchored from the top it drifted whenever the phone's
     address bar slid in or out, because that resizes the viewport - anchored from the bottom
     it rides with the bar exactly like the cart bar does). On apply it is clamped inside the
     viewport, above the home-indicator safe area, and above the bottom cart bar only when it
     would sit under it (the A-278 --wafab-lift measurement is reused, re-clamped on the same
     cart/resize events). Dropping it back into its home corner - the LEFT one since A-473 -
     clears the memory and the default rules (corner, bar lift, bazaar stacking) take over
     again. The opposite inline inset is switched off while a spot is set, so the result
     never rests on how a browser breaks the tie between two side rules. Measured against
     the LAYOUT viewport (clientWidth/Height - what position:fixed uses) and the element's
     offset size (immune to the --grab scale). Logical insets only: the stored x is physical,
     inset-inline-start is derived per writing direction. */
(function () {
  var fab = document.querySelector(".wafab[data-movable]");
  if (!fab || !window.PointerEvent || !("insetInlineStart" in fab.style)) return;
  var KEY = "t3b:wafab",
    HOLD = 350,
    SLOP = 12,
    PAD = 10,
    EDGE = 18,
    HOME = 30;
  var rtl = document.documentElement.dir === "rtl";
  var pos = null,
    cur = null,
    timer = 0,
    press = null,
    pid = null,
    dragging = false,
    held = false,
    pending = false;
  fab.style.setProperty("--wafab-sab", "env(safe-area-inset-bottom, 0px)");
  function num(v) {
    return parseFloat(v) || 0;
  }
  function lift() {
    return num(getComputedStyle(document.documentElement).getPropertyValue("--wafab-lift"));
  }
  function sab() {
    return num(getComputedStyle(fab).getPropertyValue("--wafab-sab"));
  }
  function range() {
    /* vw: the layout width (no scrollbar). vh: the VISIBLE height (innerHeight) - on phones
       the browser toolbars slide in and out, and a fixed bottom inset is measured from the
       visible bottom, not from the layout height; mixing the two put the button ~100 px
       below the finger on the owner's phone (2026-09-12). */
    var vw = document.documentElement.clientWidth || window.innerWidth,
      vh = window.innerHeight || document.documentElement.clientHeight,
      w = fab.offsetWidth || 52,
      h = fab.offsetHeight || 52;
    return {
      vw: vw,
      vh: vh,
      w: w,
      h: h,
      xmax: Math.max(PAD, vw - w - PAD),
      ybmax: Math.max(PAD, vh - h - PAD),
    };
  }
  function save() {
    try {
      if (pos) localStorage.setItem(KEY, JSON.stringify(pos));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }
  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (!v || !isFinite(v.fx)) return;
      if (isFinite(v.yb)) pos = { fx: +v.fx, yb: +v.yb };
      else if (isFinite(v.fy)) {
        /* first-day format (fraction from the top) - convert once */
        var g = range();
        pos = { fx: +v.fx, yb: Math.max(PAD, g.vh - v.fy * g.ybmax - g.h) };
        save();
      }
    } catch (e) {}
  }
  /* While the finger is down, follow it in ITS coordinates (top-anchored): no viewport height
     enters the maths, so nothing a sliding toolbar does can offset the button from the finger. */
  function follow(x, top) {
    var g = range();
    x = Math.min(Math.max(PAD, x), g.xmax);
    top = Math.min(Math.max(0, top), Math.max(0, g.vh - g.h));
    fab.style.insetInlineStart = (rtl ? g.vw - x - g.w : x) + "px";
    fab.style.insetInlineEnd = "auto";
    fab.style.insetBlockStart = top + "px";
    fab.style.insetBlockEnd = "auto";
    fab.classList.add("wafab--moved");
  }
  /* At rest: x = physical left edge, yb = distance from the visible bottom edge, both px,
     both clamped. Bottom-anchored so it rides with the toolbars exactly like the cart bar. */
  function place(x, yb) {
    var g = range();
    x = Math.min(Math.max(PAD, x), g.xmax);
    yb = Math.min(Math.max(yb, PAD + sab(), lift() + PAD), g.ybmax);
    fab.style.insetInlineStart = (rtl ? g.vw - x - g.w : x) + "px";
    fab.style.insetInlineEnd = "auto";
    fab.style.insetBlockEnd = yb + "px";
    fab.style.insetBlockStart = "auto";
    fab.classList.add("wafab--moved");
    cur = { x: x, yb: yb };
  }
  function apply() {
    if (!pos) return;
    place(pos.fx * range().xmax, pos.yb);
  }
  function reset() {
    pos = cur = null;
    fab.style.insetInlineStart =
      fab.style.insetInlineEnd =
      fab.style.insetBlockStart =
      fab.style.insetBlockEnd =
        "";
    fab.classList.remove("wafab--moved");
    save();
  }
  function grab(e) {
    var r = fab.getBoundingClientRect();
    dragging = held = true;
    press.dx = press.x - r.left;
    press.dy = press.y - r.top;
    fab.classList.add("wafab--grab");
    try {
      fab.setPointerCapture(e.pointerId);
    } catch (x) {}
    if (navigator.vibrate) {
      try {
        navigator.vibrate(12);
      } catch (x) {}
    }
  }
  function drop(e) {
    if (!press || e.pointerId !== pid) return;
    clearTimeout(timer);
    if (dragging) {
      fab.classList.remove("wafab--grab");
      var g = range(),
        x = fab.offsetLeft,
        yb = g.vh - fab.offsetTop - g.h,
        homeYb = (fab.classList.contains("wafab--flt") ? 78 : EDGE) + sab() + lift();
      /* home is the LEFT corner (x is the physical left edge) */
      if (Math.abs(x - EDGE) <= HOME && yb <= homeYb + HOME) reset();
      else {
        place(x, yb);
        pos = { fx: cur.x / g.xmax, yb: cur.yb };
        save();
      }
      try {
        fab.releasePointerCapture(e.pointerId);
      } catch (x) {}
    }
    dragging = false;
    press = null;
    pid = null;
  }
  fab.addEventListener("pointerdown", function (e) {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    pid = e.pointerId;
    held = false;
    dragging = false;
    press = { x: e.clientX, y: e.clientY, dx: 0, dy: 0 };
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (press && pid === e.pointerId && !dragging) grab(e);
    }, HOLD);
  });
  fab.addEventListener("pointermove", function (e) {
    if (!press || e.pointerId !== pid) return;
    if (!dragging) {
      if (Math.abs(e.clientX - press.x) > SLOP || Math.abs(e.clientY - press.y) > SLOP) {
        clearTimeout(timer);
        press = null;
        pid = null;
      }
      return;
    }
    follow(e.clientX - press.dx, e.clientY - press.dy);
  });
  fab.addEventListener("pointerup", drop);
  fab.addEventListener("pointercancel", drop);
  fab.addEventListener(
    "click",
    function (e) {
      if (held) {
        e.preventDefault();
        e.stopImmediatePropagation();
        held = false;
      }
    },
    true,
  );
  fab.addEventListener("contextmenu", function (e) {
    if (press || dragging || held) e.preventDefault();
  });
  fab.addEventListener("dragstart", function (e) {
    e.preventDefault();
  });
  function queue() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      apply();
    }, 360);
  }
  document.addEventListener("t3b:cart", queue);
  window.addEventListener("resize", queue);
  window.addEventListener("pageshow", queue);
  load();
  apply();
})();

/* A-280 (owner: the cart display must LOCK to the truth): pressing Back restores a
     bfcache SNAPSHOT of the page from before the last cart change - the cart itself never
     changed on the server, but the badge and bar showed the old frame until a refresh.
     On every pageshow the server cart is refetched; if the badge disagrees with it, or
     the page is a bfcache restore (ev.persisted - deeper state like the drawer's line
     items can be stale even when the count happens to match), t3b:cart is re-dispatched.
     That event is the one full-repaint funnel: badge, top meter, cart bar, open drawer.
     On an ordinary fresh load the badge already matches and nothing fires - no spurious
     badge bump, no spurious screen-reader announcement. */
(function () {
  var LR = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  window.addEventListener("pageshow", function (ev) {
    /* AUDIT B-12/P-1: on an ordinary fresh load this fired a second identical
       cart.js right next to the drawer's boot fetch. The reconcile exists for
       bfcache restores - only run it there; fresh loads are already truthful. */
    if (!ev.persisted) return;
    fetch(LR + "cart.js")
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (c) {
        if (!c) return;
        var badge = document.querySelector(".cartb i");
        var shown = badge ? parseInt(badge.textContent, 10) : NaN;
        if (ev.persisted || shown !== c.item_count) {
          document.dispatchEvent(new CustomEvent("t3b:cart", { detail: c }));
        }
      })
      .catch(function () {
        /* offline back-nav: leave the snapshot rather than guess */
      });
  });
})();

/* A-311: the chip flag is a server-rendered SVG now (Liquid, flag-svg snippet) - the
     emoji module that stood here is retired; Windows drew emoji flags as letter pairs. */

/* A-296: locale modal wiring. Class-driven like the drawers; ESC and the scrim close;
     the currency line follows the highlighted country instantly - reading the value
     Shopify itself attached to that country, never a number invented here. */
(function () {
  var openBtn = document.querySelector("[data-lcm-open]");
  var panel = document.querySelector("[data-lcm]");
  if (!openBtn || !panel) return;
  function setOpen(on) {
    document.documentElement.classList.toggle("lcm-open", on);
    if (on) {
      var f = panel.querySelector("input:checked") || panel;
      if (f.focus) f.focus();
    } else openBtn.focus();
  }
  openBtn.addEventListener("click", function () {
    setOpen(true);
  });
  document.querySelectorAll("[data-lcm-close]").forEach(function (x) {
    x.addEventListener("click", function () {
      setOpen(false);
    });
  });
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "Escape" &&
      document.documentElement.classList.contains("lcm-open")
    )
      setOpen(false);
  });
  /* A-311: the read-only currency line was removed at the owner's instruction - the
       currency already sits on every country row. */
  /* A-351: the Global display-currency choice rides a cart attribute so every
       server render (tiles, cart, checkout line) agrees. Persist it, then let the
       localization form continue; the reload re-renders in the chosen currency. */
  var lcmForm = panel.querySelector("form");
  /* The bfcache trap: Back restores the page with
     تطبيق still disabled+busy from the submit that navigated away. */
  window.addEventListener("pageshow", function () {
    var b = lcmForm && lcmForm.querySelector(".lcm-apply");
    if (b) {
      b.disabled = false;
      b.classList.remove("busy");
    }
  });
  if (lcmForm)
    lcmForm.addEventListener("submit", function (e) {
      /* A-358: busy state the instant تطبيق is pressed. The platform's own
         redirect + render takes ~2s and used to read as a frozen modal; the
         button has no name/value so disabling it cannot change the POST. */
      var applyBtn = lcmForm.querySelector(".lcm-apply");
      if (applyBtn) {
        applyBtn.disabled = true;
        applyBtn.classList.add("busy");
      }
      /* A-358: the t3b-gcur cart write is slow (~0.6-1.4s) and only matters
         when the customer picked the Global market AND actually changed the
         currency. Everyone else (every GCC country or language switch) now
         navigates immediately on the native submit. data-gcur carries the
         server's current value. */
      var g = lcmForm.querySelector('input[name="t3b_gcur"]:checked');
      var c = lcmForm.querySelector('input[name="country_code"]:checked');
      var cur = (lcmForm.getAttribute("data-gcur") || "USD").toUpperCase();
      if (!g || !c || c.value !== "US" || g.value.toUpperCase() === cur) return;
      e.preventDefault();
      /* AUDIT B-18: the guard timer and the fetch settling can BOTH call go
         when the write outlives 600ms - a one-shot latch stops the second
         submit firing mid-navigation. */
      var went = false;
      var go = function () {
        if (went) return;
        went = true;
        lcmForm.submit();
      };
      /* outside the main closure: derive the locale root from the global config */
      var lcmRoot =
        window.T3B && T3B.root && T3B.root !== "/"
          ? String(T3B.root).replace(/\/$/, "")
          : "";
      /* keepalive lets the write finish during the navigation it no longer
         blocks; the guard is a floor, not the norm. Worst case (write slower
         than the whole reload) is one render in the old currency - the same
         worst case the old 1200ms guard accepted. */
      var guard = setTimeout(go, 600); // the modal must NEVER hang on a failed fetch
      fetch(lcmRoot + "/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({ attributes: { "t3b-gcur": g.value } }),
      }).then(
        function () {
          clearTimeout(guard);
          go();
        },
        function () {
          clearTimeout(guard);
          go();
        },
      );
    });
})();
